/*
 * Ollie, Express Matting's AI rubber matting specialist (expressmatting.co.uk). Built from Harry's front end (Plastics Co UK), from Archie's
 * (light design, echo-cancelled hands-free voice, product shelf), plus cut-to-size panels ([[cut:...]] tags
 * that add a custom polycarbonate cut straight to the basket, exactly as the product page's calculator does),
 * "Add all to basket" for multi-item quotes, and ex-VAT prices on every quote for trade buyers.
 * Chat window (launcher bottom left) + "Questions about this product?" box under Add to cart on product pages.
 * The expert lives in the Cloudflare Worker shared with Hugo (Gym Flooring UK), Ted (Tarpaulins UK) and
 * Rory (Rubber Roof UK) and Stan (Stair Nosings UK); it picks Ollie from the page's origin. Replies stream in and are read aloud
 * (British voice) unless the customer mutes. Customers can tap the big "Tap to talk to Ollie" button and speak.
 * Snippet: snippets/ollie.liquid (sets data-ai on #olliePanel). Styles: assets/ollie.css.
 */
(function () {
  'use strict';
  var panel = document.getElementById('olliePanel');
  if (!panel || window.OllieChat) return;

  var AI_URL = panel.getAttribute('data-ai') || '';
  var BASE = AI_URL.replace(/\/chat\/?$/, '');
  var TTS_URL = BASE ? BASE + '/tts' : '';
  var STT_URL = BASE ? BASE + '/stt' : '';
  var PHONE = '01744 520 110', TEL = 'tel:01744520110';
  var EMAIL = 'sales@expressmatting.co.uk';
  var TEAM = 'Call <a href="' + TEL + '">' + PHONE + '</a> or email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> (Mon-Fri, 8am-7pm).';
  var STORE_KEY = 'ollie_state_v1', VOICE_KEY = 'ollie_voice_v1';

  var launch = document.getElementById('ollieLaunch');
  var log = document.getElementById('ollieLog');
  var chips = document.getElementById('ollieChips');
  var form = document.getElementById('ollieForm');
  var input = document.getElementById('ollieInput');
  var statusEl = document.getElementById('ollieStatus');
  var STATUS = 'AI matting specialist \u00B7 replies in seconds';

  var convo = [], history = [], busy = false;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(pence) { return '\u00A3' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function track(action, source) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: action, sn_source: source || 'unknown' }); } catch (e) {}
  }

  // ---------- Markdown-lite rendering ----------
  function renderMd(src) {
    var lines = esc(src).split('\n'), out = '', list = '';
    function closeList() { if (list) { out += '</' + list + '>'; list = ''; } }
    lines.forEach(function (ln) {
      var m;
      if ((m = ln.match(/^\s*[-\u2022*]\s+(.*)$/))) { if (list !== 'ul') { closeList(); out += '<ul>'; list = 'ul'; } out += '<li>' + m[1] + '</li>'; return; }
      if ((m = ln.match(/^\s*\d+[.)]\s+(.*)$/))) { if (list !== 'ol') { closeList(); out += '<ol>'; list = 'ol'; } out += '<li>' + m[1] + '</li>'; return; }
      closeList();
      if (ln.trim()) out += '<p>' + ln + '</p>';
    });
    closeList();
    return out.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>').replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (all, t, u) {
      var href = u.replace(/&amp;/g, '&');
      var ok = /^\/(?!\/)/.test(href) || /^https:\/\/(www\.)?expressmatting\.co\.uk\//i.test(href) || /^tel:|^mailto:sales@expressmatting\.co\.uk$/i.test(href) || /^https:\/\/wa\.me\/447822012977/.test(href);
      if (!ok) return t;
      var ext = /^https:\/\/wa\.me/.test(href);
      return '<a href="' + esc(href) + '"' + (ext ? ' target="_blank" rel="nofollow noopener"' : '') + '>' + t + '</a>';
    });
  }
  function visibleText(full) { return full.replace(/\[\[[^\]]*\]\]/g, '').replace(/\[\[[^\]]*$/, '').trim(); }

  // ---------- Product cards and quotes (filled in after the reply renders) ----------
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return productCache[handle];
  }
  function getVariants(ids) {
    if (!BASE || !ids.length) return Promise.resolve({});
    return fetch(BASE + '/variant?ids=' + ids.join(','), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : { variants: {} }; })
      .then(function (j) { return j.variants || {}; })
      .catch(function () { return {}; });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function cardHtml(p) {
    var price = p.price_min !== p.price_max ? 'From ' + money(p.price_min) : money(p.price_min);
    var img = p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ollie-card__ph"></span>';
    return '<div class="ollie-card">' + img + '<div class="ollie-card__body"><div class="ollie-card__name">' + esc(p.title) +
      '</div><div class="ollie-card__price">' + price + '</div><a class="ollie-card__link" href="/products/' + esc(p.handle) + '">View product</a></div></div>';
  }
  function quoteHtml(id, qty, v) {
    qty = Math.max(1, Math.min(999, parseInt(qty, 10) || 1));
    if (!v || !(v.price > 0)) return '';
    var opt = v.title && v.title !== 'Default Title' ? '<div><span>Option</span><b>' + esc(v.title) + '</b></div>' : '';
    var btn = v.available ? '<button type="button" class="ollie-add" data-v="' + esc(id) + '" data-q="' + qty + '" data-h="' + esc(v.handle) + '">Add ' + qty + ' to basket</button>'
      : '<small>This option is currently unavailable online; please call us.</small>';
    return '<div class="ollie-quote"><div><span>Product</span><b><a href="/products/' + esc(v.handle) + '?variant=' + esc(id) + '">' + esc(v.product) + '</a></b></div>' + opt +
      '<div><span>Quantity</span><b>' + qty + ' x ' + money(v.price) + '</b></div><div><span>Total</span><b>' + money(v.price * qty) + '</b></div>' +
      '<small>Inc. VAT (' + money(Math.round(v.price * qty / 1.2)) + ' ex VAT) \u00B7 Free UK delivery</small>' + btn + '</div>';
  }
  // Cut to size. Two kinds of [[cut]] tag, both written by the Worker's tools:
  //  - clear polycarbonate (cut_to_size, 5 fields VARIANT:QTY:W:H): one cut panel per stock sheet, exactly what
  //    the product page's calculator puts in the basket;
  //  - any other sheet or rod (cut_quote, 6 fields VARIANT:SHEETS:W:H:PIECES, H = 0 for a rod length): several
  //    pieces cut from the listed sheets or rod lengths, cutting free. The basket line is the stock (quantity =
  //    sheets or lengths) with the cut size and number of pieces on it, so the order says exactly what to cut.
  // 4300 -> "4.3m", 2000 -> "2m"
  function metres(mm) { return (Math.round(mm / 10) / 100).toString() + 'm'; }
  function cutParts(v) {
    var parts = String(v && v.title || '').split(' / ');
    var size = (parts[0] || '').match(/\d+/g) || [];
    return { label: (parts[0] || '').trim(), t: parseFloat(parts[1]) || 0, sw: +size[0] || 0, sh: +size[1] || 0 };
  }
  function cutOk(c, v) {
    if (!v || !(v.price > 0)) return false;
    if (c.pieces) return c.q >= 1 && c.q <= 200 && c.pieces >= 1 && c.pieces <= 5000 && c.w > 0 && c.h >= 0;
    if (!/polycarbonate/i.test(v.product || '')) return false;
    var p = cutParts(v), L = Math.max(c.w, c.h), S = Math.min(c.w, c.h);
    return p.t > 0 && S >= 100 && L <= 3050 && S <= 2050 && L <= Math.max(p.sw, p.sh) && S <= Math.min(p.sw, p.sh) && c.q >= 1 && c.q <= 100;
  }
  function cutHtml(c, v) {
    if (!cutOk(c, v)) return '';
    var total = v.price * c.q, exv = ' · Inc. VAT (' + money(Math.round(total / 1.2)) + ' ex VAT) · Delivery at checkout';
    if (c.pieces && !c.h) {
      // Express Matting cut lengths: sold by the metre (quantity = metres), cut into the customer's pieces.
      var opt = v.title && v.title !== 'Default Title' ? v.title : '';
      var each = metres(c.w);
      var lbtn = v.available ? '<button type="button" class="ollie-add" data-v="' + esc(c.id) + '" data-q="' + c.q + '" data-cw="' + c.w + '" data-ch="0" data-cp="' + c.pieces + '">Add ' + c.q + 'm to basket</button>'
        : '<small>That size is currently unavailable online.</small>';
      return '<div class="ollie-quote"><div><span>Product</span><b><a href="/products/' + esc(v.handle) + '?variant=' + esc(c.id) + '">' + esc(String(v.product).split('|')[0].trim()) + '</a></b></div>' +
        (opt ? '<div><span>Option</span><b>' + esc(opt) + '</b></div>' : '') +
        '<div><span>Length</span><b>' + c.q + 'm x ' + money(v.price) + '</b></div>' +
        (c.pieces > 1 || c.w / 1000 !== c.q ? '<div><span>Cut into</span><b>' + c.pieces + ' x ' + each + '</b></div>' : '') +
        '<div><span>Total</span><b>' + money(total) + '</b></div>' +
        '<small>Cut to your length in our Burnley warehouse' + exv + '</small>' + lbtn + '</div>';
    }
    if (c.pieces) {
      var rod = !c.h, size = rod ? c.w + 'mm lengths' : c.w + ' x ' + c.h + 'mm', from = (v.title && v.title !== 'Default Title' ? v.title : '');
      var name = String(v.product).split('|')[0].trim();
      var gbtn = v.available ? '<button type="button" class="ollie-add" data-v="' + esc(c.id) + '" data-q="' + c.q + '" data-cw="' + c.w + '" data-ch="' + c.h + '" data-cp="' + c.pieces + '" data-cf="' + esc(from) + '">Add ' + c.pieces + ' cut piece' + (c.pieces > 1 ? 's' : '') + ' to basket</button>'
        : '<small>That stock size is currently unavailable online.</small>';
      return '<div class="ollie-quote"><div><span>Cut to size</span><b><a href="/products/' + esc(v.handle) + '">' + c.pieces + ' x ' + esc(size) + '</a></b></div>' +
        '<div><span>Material</span><b>' + esc(name) + '</b></div><div><span>Cut from</span><b>' + c.q + ' x ' + esc(from) + '</b></div>' +
        '<div><span>Total</span><b>' + money(total) + '</b></div>' +
        '<small>' + money(Math.round(total / c.pieces)) + ' a piece · cutting free' + exv + '</small>' + gbtn + '</div>';
    }
    var p = cutParts(v);
    var btn = v.available ? '<button type="button" class="ollie-add" data-v="' + esc(c.id) + '" data-q="' + c.q + '" data-cw="' + c.w + '" data-ch="' + c.h + '" data-ct="' + p.t + '" data-cf="' + esc(p.label) + ' sheet">Add ' + c.q + ' cut panel' + (c.q > 1 ? 's' : '') + ' to basket</button>'
      : '<small>This thickness is currently unavailable online.</small>';
    return '<div class="ollie-quote"><div><span>Cut to size</span><b><a href="/products/' + esc(v.handle) + '">' + c.w + ' x ' + c.h + 'mm clear polycarbonate</a></b></div>' +
      '<div><span>Thickness</span><b>' + p.t + 'mm</b></div><div><span>Quantity</span><b>' + c.q + ' x ' + money(v.price) + '</b></div><div><span>Total</span><b>' + money(total) + '</b></div>' +
      '<small>Cut from a ' + esc(p.label) + ' sheet · cutting included' + exv + '</small>' + btn + '</div>';
  }
  // Every basket line Ollie adds carries a hidden "_via: Ollie" property (underscored properties don't show to
  // the customer, but appear on the order), so sales from Ollie can be counted.
  function cartLine(btn) {
    var line = { id: +btn.getAttribute('data-v'), quantity: +btn.getAttribute('data-q'), properties: { _via: 'Ollie' } };
    if (btn.hasAttribute('data-cw') && !+btn.getAttribute('data-ch') && btn.getAttribute('data-cp')) {
      // Cut lengths: the same "Cut into" note the product page's own cutting option writes on the order.
      line.properties = { 'Cut into': btn.getAttribute('data-cp') + ' x ' + metres(+btn.getAttribute('data-cw')), _via: 'Ollie' };
      return line;
    }
    if (btn.hasAttribute('data-cw')) {
      var w = btn.getAttribute('data-cw'), h = +btn.getAttribute('data-ch'), pieces = btn.getAttribute('data-cp');
      line.properties = { 'Cut size': h ? w + ' x ' + h + 'mm' : w + 'mm lengths' };
      if (pieces) line.properties['Pieces'] = pieces;
      if (btn.getAttribute('data-ct')) line.properties['Thickness'] = btn.getAttribute('data-ct') + 'mm';
      line.properties['Cut from'] = btn.getAttribute('data-cf');
      line.properties['Cut ref'] = 'PC-' + Date.now().toString(36).toUpperCase();
      line.properties._via = 'Ollie';
    }
    return line;
  }

  // ---------- Measuring Ollie: cart attributes travel onto the order ("Additional details" in the admin) ----------
  // "Ollie: chatted" when the customer asks him anything; "Ollie: added to basket" once he adds something.
  // Only ever upgrades (chatted -> added), set once per visit.
  var cartMark = '';
  try { cartMark = sessionStorage.getItem('ollie_mark') || ''; } catch (e) {}
  function markCart(level) {
    if (cartMark === 'added to basket' || cartMark === level) return;
    cartMark = level;
    try { sessionStorage.setItem('ollie_mark', level); } catch (e) {}
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Ollie: level } }) }).catch(function () {});
  }

  // ---------- Ollie sees the basket ----------
  // A compact, numbered summary of the live basket goes with each message, with a short note on how to use it.
  // Numbers match [[setqty:LINE:QUANTITY]], which shows an "Update basket" card (0 removes the line).
  var lastCart = null;
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function shortTitle(t) { return String(t || '').split('|')[0].replace(/\s+/g, ' ').trim().slice(0, 70); }
  function basketNote() {
    return getCart().then(function (cart) {
      lastCart = cart;
      if (!cart) return '';
      if (!cart.items || !cart.items.length) return '[Basket: empty]';
      var lines = cart.items.slice(0, 25).map(function (it, i) {
        var p = it.properties || {}, cut = [];
        ['Cut size', 'Pieces', 'Thickness', 'Cut from'].forEach(function (k) { if (p[k]) cut.push(k + ' ' + p[k]); });
        return (i + 1) + ') ' + shortTitle(it.product_title) + (it.variant_title ? ' - ' + it.variant_title : '') + ' (variant ' + it.variant_id + ') x' + it.quantity +
          ' = ' + money(it.final_line_price) + (cut.length ? ' [' + cut.join('; ') + ']' : '');
      });
      var note = '[Customer\'s basket right now (live): ' + lines.join(' | ') + (cart.items.length > 25 ? ' | +' + (cart.items.length - 25) + ' more lines' : '') +
        ' | Total ' + money(cart.total_price) + ' inc VAT (' + money(Math.round(cart.total_price / 1.2)) + ' ex VAT), delivery added at checkout.' +
        ' Use it when it helps: answer total or basket questions from it; check quantities and sizes against what they told you; flag anything the job is missing (offer it with a [[quote]]), duplicates, or a cheaper identical size; to change a quantity write [[setqty:LINE:QUANTITY]] using the line number above (0 removes it). Don\'t list the basket back unless asked.]';
      return note.slice(0, 1800);
    });
  }
  function setQtyHtml(line, qty) {
    var it = lastCart && lastCart.items && lastCart.items[line - 1];
    if (!it || !(qty >= 0) || qty > 9999) return '';
    var name = shortTitle(it.product_title) + (it.variant_title ? ' · ' + it.variant_title : '');
    return '<div class="ollie-quote ollie-setqty"><div><span>Your basket</span><b>' + esc(name) + '</b></div>' +
      '<div><span>Change</span><b>' + it.quantity + ' → ' + (qty === 0 ? 'remove' : qty) + '</b></div>' +
      '<button type="button" class="ollie-add" data-setqty-key="' + esc(it.key) + '" data-setqty="' + qty + '">' + (qty === 0 ? 'Remove from basket' : 'Update basket') + '</button></div>';
  }
  function setQty(btn) {
    btn.disabled = true; btn.textContent = 'Updating…';
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-setqty-key'), quantity: +btn.getAttribute('data-setqty') }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (cart) {
        lastCart = cart; btn.classList.add('is-added'); btn.innerHTML = '✓ Updated';
        showBasket(cart, btn, 'Basket updated'); track('basket_change', 'ollie'); save(); if (PDP) pdpSave();
        if (/^\/cart\/?$/.test(location.pathname)) setTimeout(function () { location.reload(); }, 900);
      })
      .catch(function (e) { btn.disabled = false; btn.textContent = 'Try again'; btn.title = e && e.description || ''; });
  }
  // The basket page is the customer's own: Ollie never pops up or opens there by himself (it confused
  // customers on their way to pay). The launcher stays, so anyone who wants him can still open him.
  function onBasketPage() { return /^\/cart\/?$/.test(location.pathname); }

  // ---------- Basket bar: after adding, the customer stays in the conversation ----------
  function basketHtml(cart, title) {
    return '<div class="ollie-basket" role="status"><span class="ollie-basket__ic" aria-hidden="true">' + BASKET_SVG + '</span>' +
      // The basket total, not a count: cut pieces are sold as the stock sheets they come from, so a count would
      // read "6 items" for 12 pieces.
      '<span class="ollie-basket__txt"><b>' + (title || 'Added to your basket') + '</b><small>Basket total ' + money(cart.total_price || 0) + ' inc. VAT</small></span>' +
      '<a class="ollie-basket__view" href="/cart">View basket</a><a class="ollie-basket__go" href="/checkout">Checkout</a></div>';
  }
  function showBasket(cart, btn, title) {
    var html = basketHtml(cart, title);
    // Where the customer is: the voice screen, the product-page box, or the chat window.
    var host = vmOn() ? vmEl : btn.closest('.ollie-e') || panel;
    var old = host.querySelector('.ollie-basket'); if (old) old.remove();
    var anchor = vmOn() ? vmEl.querySelector('.ollie-vm__chips') : host === panel ? chips : host.querySelector('.ollie-e__chips');
    if (anchor) anchor.insertAdjacentHTML('beforebegin', html); else host.insertAdjacentHTML('beforeend', html);
    // Let the theme's own basket count and drawer catch up.
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count'), function (el) { if (/^\d*$/.test(el.textContent.trim())) el.textContent = cart.item_count; });
  }
  // ---------- Bespoke quote request, sent from the chat ----------
  // Ollie writes [[lead:JOB SUMMARY]] for jobs he can't price by rule (cut lists, shapes, machining, bulk,
  // certificates). The customer adds their details and it goes through the store's own Shopify contact form,
  // exactly like the Get a Quote page (same inbox, same spam protection), with the job already written up.
  var leadSeq = 0;
  function leadHtml(summary) {
    var n = ++leadSeq;
    var id = function (k) { return 'ollie-lead-' + n + '-' + k; };
    return '<div class="ollie-lead" data-ollie-lead role="form" aria-label="Quote request">' +
      '<div class="ollie-lead__head"><b>Get your exact price by email</b><small>Free, no obligation · with you the same working day (Mon–Fri)</small></div>' +
      '<label for="' + id('job') + '">Your job</label><textarea id="' + id('job') + '" name="job" rows="4" required>' + esc(summary) + '</textarea>' +
      '<div class="ollie-lead__row"><div><label for="' + id('name') + '">Name *</label><input id="' + id('name') + '" name="name" autocomplete="name" required></div>' +
      '<div><label for="' + id('email') + '">Email *</label><input id="' + id('email') + '" name="email" type="email" autocomplete="email" autocapitalize="off" spellcheck="false" required></div></div>' +
      '<div class="ollie-lead__row"><div><label for="' + id('phone') + '">Phone</label><input id="' + id('phone') + '" name="phone" type="tel" autocomplete="tel" placeholder="Optional"></div>' +
      '<div><label for="' + id('co') + '">Company</label><input id="' + id('co') + '" name="company" autocomplete="organization" placeholder="Optional"></div></div>' +
      '<button type="button" class="ollie-lead__send" data-ollie-lead-send>Email me my price</button>' +
      '<p class="ollie-lead__note">We only use your details to send your price. <a href="/policies/privacy-policy">Privacy policy</a></p>' +
      '<p class="ollie-lead__err" hidden role="alert"></p></div>';
  }
  function leadContext(f) {
    // The conversation so far (last few turns), so whoever prices it sees what was discussed.
    var c = PDP && f.closest('.ollie-e') ? PDP.convo : convo;
    return c.slice(-8).map(function (m) { return (m.role === 'user' ? 'Customer: ' : 'Ollie: ') + visibleText(String(m.content).replace(/^\[[^\]]*\]\n/gm, '')).slice(0, 700); }).join('\n\n');
  }
  function sendLead(f) {
    var err = f.querySelector('.ollie-lead__err'), btn = f.querySelector('.ollie-lead__send');
    var field = function (n) { return f.querySelector('[name="' + n + '"]'); };
    var v = function (n) { var el = field(n); return el ? el.value.trim() : ''; };
    var bad = !v('name') ? 'name' : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v('email')) ? 'email' : !v('job') ? 'job' : '';
    if (bad) { err.hidden = false; err.textContent = bad === 'email' ? 'Please enter a valid email address.' : bad === 'name' ? 'Please enter your name.' : 'Please describe the job.'; field(bad).focus(); return; }
    err.hidden = true; btn.disabled = true; btn.textContent = 'Sending…';
    var fields = {
      form_type: 'contact', utf8: '✓',
      'contact[Request type]': 'Quote request (via Ollie, the AI chat)',
      'contact[name]': v('name'), 'contact[email]': v('email'), 'contact[phone]': v('phone'), 'contact[Company]': v('company'),
      'contact[Product / material]': v('job').split('\n')[0].slice(0, 200),
      'contact[Sent from]': location.href.split('#')[0],
      'contact[body]': v('job') + '\n\n--- Chat with Ollie ---\n' + leadContext(f)
    };
    // Shopify protects contact forms with an invisible hCaptcha. It only switches on for a real form that has
    // been focused, and it blocks the submit of any form it hasn't switched on; a background fetch without its
    // token is refused ("Missing CAPTCHA token"). So: build a real (hidden) form on the page, switch the check
    // on with a focus event, then submit it. Shopify runs the check (a puzzle shows on this page only if it
    // needs one), adds its token and calls form.submit(), which we take over to send the same form data in
    // the background, so the customer stays in the chat and we can read the result ("contact_posted=true").
    // It arrives in the store inbox exactly like the Get a Quote page.
    var real = document.createElement('form'); real.method = 'post'; real.action = '/contact#contact_form';
    real.setAttribute('accept-charset', 'UTF-8'); real.hidden = true; real.className = 'ollie-lead-real';
    Object.keys(fields).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; real.appendChild(i); });
    document.body.appendChild(real);
    var finished = false;
    function fail(msg) {
      if (finished) return; finished = true; real.remove();
      btn.disabled = false; btn.textContent = 'Email me my price';
      err.hidden = false; err.innerHTML = msg;
    }
    var giveUp = setTimeout(function () { track('lead_timeout', 'ollie'); fail('Sorry, that’s taking too long. Please email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> or call <a href="' + TEL + '">' + PHONE + '</a>.'); }, 60000);
    real.submit = function () {
      fetch('/contact', { method: 'POST', body: new URLSearchParams(new FormData(real)), credentials: 'same-origin' })
        .then(function (r) {
          if (finished) return;
          if (/contact_posted=true/.test(r.url)) {
            finished = true; clearTimeout(giveUp); real.remove();
            f.outerHTML = '<div class="ollie-lead ollie-lead--done" role="status"><b>✓ Done: your exact price is on its way</b><small>It’ll be emailed to ' + esc(v('email')) + ' the same working day (Mon–Fri). Just reply to that email to go ahead.</small></div>';
            track('lead_sent', 'ollie');
            return;
          }
          // Shopify wants its "I'm not a robot" tick: exactly what its own forms do, go to its check page (it has
          // already kept the request in this tab), where one tick sends it and brings the customer back here.
          // On return the chat reopens with the confirmation (see leadReturn).
          if (/\/challenge/.test(r.url)) {
            finished = true; clearTimeout(giveUp);
            try { sessionStorage.setItem('ollie_lead_pending', v('email')); } catch (e) {}
            track('lead_challenge', 'ollie'); save(); if (PDP) pdpSave();
            btn.textContent = 'One quick tick to confirm…';
            err.hidden = false; err.style.color = 'inherit';
            err.textContent = 'Taking you to a one-tick “I’m not a robot” check, then straight back here.';
            setTimeout(function () { location.href = r.url; }, 1200);
            return;
          }
          track('lead_failed', 'ollie'); clearTimeout(giveUp);
          fail('Sorry, that didn’t go through. Please email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> or call <a href="' + TEL + '">' + PHONE + '</a>.');
        })
        .catch(function () { clearTimeout(giveUp); fail('Sorry, that didn’t send. Please try again, or email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a>.'); });
    };
    real.elements[0].dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
    var tries = 0;
    (function go() {
      if (finished) return;
      // Submit once Shopify has switched its check on for this form (or after 8 seconds, in case it never does).
      if (real.dataset.hcaptchaBound || real.dataset.recaptchaBound || ++tries > 40) {
        if (real.requestSubmit) real.requestSubmit(); else real.submit();
        return;
      }
      setTimeout(go, 200);
    })();
  }

  // Turns the reply's [[...]] tags into placeholders, returns chips + async fill job.
  function renderReply(text, holder) {
    var chipList = null, note = '', products = [], quotes = [], lead = null, setqtys = [];
    var body = text.replace(/\[\[(product|quote|cut|lead|setqty|chips|refusal|error)(?::([^\]]*))?\]\]/g, function (all, kind, arg) {
      arg = arg || '';
      if (kind === 'setqty') { var sq = arg.split(':'); setqtys.push({ line: parseInt(sq[0], 10), q: parseInt(sq[1], 10) }); }
      else if (kind === 'lead') lead = arg.trim();
      else if (kind === 'product') products.push(arg.trim());
      else if (kind === 'quote') { var b = arg.split(':'); if (/^\d+$/.test(b[0])) quotes.push({ id: b[0], q: b[1] }); }
      else if (kind === 'cut') {
        var c = arg.split(':').map(function (s) { return s.trim(); });
        if (/^\d+$/.test(c[0])) quotes.push({ id: c[0], q: c[1], cut: { id: c[0], q: Math.round(+c[1] || 1), w: Math.round(+c[2]), h: Math.round(+c[3] || 0), pieces: c.length > 4 ? Math.round(+c[4] || 0) : 0 } });
      }
      else if (kind === 'chips') chipList = arg.split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4);
      else note = "Sorry, I can't help with that one here. You can reach us directly: " + TEAM;
      return '';
    });
    holder.innerHTML = renderMd(body.replace(/\[\[[^\]]*$/, '').trim()) + (note ? '<p>' + note + '</p>' : '') + '<div class="ollie-extras"></div>';
    var extras = holder.querySelector('.ollie-extras');
    var jobs = [], items = products.map(function (h) { return { h: h }; });
    products.forEach(function (h) {
      var slot = document.createElement('div'); extras.appendChild(slot);
      jobs.push(getProduct(h).then(function (p) { slot.outerHTML = cardHtml(p); }).catch(function () { slot.remove(); }));
    });
    if (quotes.length) {
      var qslots = quotes.map(function () { var s = document.createElement('div'); extras.appendChild(s); return s; });
      var allSlot = document.createElement('div'); extras.appendChild(allSlot);
      jobs.push(getVariants(quotes.map(function (q) { return q.id; })).then(function (vs) {
        var shown = 0, total = 0;
        quotes.forEach(function (q, i) {
          var v = vs[q.id], h = q.cut ? cutHtml(q.cut, v) : quoteHtml(q.id, q.q, v);
          if (h) { qslots[i].outerHTML = h; if (v.available) { shown++; total += v.price * Math.max(1, Math.min(999, parseInt(q.q, 10) || 1)); } } else qslots[i].remove();
          if (v && v.handle && h && !q.cut) {
            items = items.filter(function (it) { return it.h !== v.handle; });
            items.push({ h: v.handle, id: q.id, v: v, q: q.q });
          }
        });
        // Several items for one job: one button puts the whole list in the basket.
        // Alternatives (two ways to cut the same pieces, or two sizes of the same product) are a choice, not a
        // list: "Add all" only appears when every quote is a different item.
        var keys = quotes.map(function (q) { var v = vs[q.id]; return q.cut ? 'cut:' + q.cut.w + 'x' + q.cut.h + ':' + (q.cut.pieces || q.cut.q) : 'p:' + (v && v.handle); });
        var distinct = keys.every(function (k, i) { return keys.indexOf(k) === i; });
        if (shown > 1 && distinct) allSlot.outerHTML = '<button type="button" class="ollie-add ollie-add--all" data-add-all>Add all ' + shown + ' items to basket · ' + money(total) + '</button>';
        else allSlot.remove();
      }));
    }
    setqtys.forEach(function (s) { var h = setQtyHtml(s.line, s.q); if (h) extras.insertAdjacentHTML('beforeend', h); });
    if (lead !== null) extras.insertAdjacentHTML('beforeend', leadHtml(lead));
    // items: every product this reply showed ({h: handle, v: the quoted variant if any}), once done resolves.
    return { chips: chipList, done: Promise.all(jobs), items: function () { return items; } };
  }

  // Puts one quote (or, for "Add all", every quote in that reply) in the basket and goes to it.
  function addToCart(btn) {
    var buttons = [btn];
    if (btn.hasAttribute('data-add-all')) {
      var box = btn.parentNode;
      buttons = [].filter.call(box.querySelectorAll('.ollie-add[data-v]'), function (b) { return !b.disabled; });
      if (!buttons.length) return;
    }
    var label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: buttons.map(cartLine) }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        markCart('added to basket');
        track(btn.hasAttribute('data-add-all') ? 'add_all_to_cart' : buttons[0].hasAttribute('data-cw') ? 'add_cut_to_cart' : 'add_to_cart', 'ollie');
        // Mark every button that went in (an "Add all" adds each quote) as done; the customer stays in the chat.
        buttons.concat(btn).forEach(function (b) { b.disabled = true; b.classList.add('is-added'); b.innerHTML = '✓ Added'; });
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) showBasket(cart, btn); save(); if (PDP) pdpSave(); })
      .catch(function (e) { btn.disabled = false; btn.innerHTML = label; btn.title = e && e.description ? e.description : 'Please try again'; if (e && e.description) btn.insertAdjacentHTML('afterend', '<small class="ollie-add__err">' + esc(e.description) + '</small>'); });
  }

  // ---------- Speech: numbers and sizes the way a person says them ----------
  var ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  var TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  function words(n) {
    n = Math.floor(n);
    if (n < 20) return ONES[n];
    if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? '-' + ONES[n % 10] : '');
    if (n < 1000) return ONES[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + words(n % 100) : '');
    if (n < 1e6) { var r = n % 1000; return words(Math.floor(n / 1000)) + ' thousand' + (r ? (r < 100 ? ' and ' : ' ') + words(r) : ''); }
    return String(n);
  }
  function numWords(s) {
    s = String(s).replace(/,/g, '');
    var p = s.split('.'), w = p[1] && !(parseInt(p[0], 10) || 0) ? 'nought' : words(parseInt(p[0], 10) || 0);
    if (p[1]) w += ' point ' + p[1].split('').map(function (d) { return ONES[+d]; }).join(' ');
    return w;
  }
  var UNIT = { mm: 'millimetres', cm: 'centimetres', m: 'metres', ft: 'feet', kg: 'kilos', gsm: 'g s m' };
  var NUM = '(\\d[\\d,]*(?:\\.\\d+)?)';
  function spoken(text) {
    var t = String(text).replace(/\[\[[^\]]*\]\]/g, ' ').replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/\*\*/g, '').replace(/^\s*[-\u2022*]\s+/gm, '');
    t = t.replace(/\b0\d{3,4}[\s-]?\d{3}[\s-]?\d{3,4}\b/g, function (m) {
      return m.split(/[\s-]+/).map(function (g) { return g.split('').map(function (d) { return d === '0' ? 'oh' : ONES[+d]; }).join(' '); }).join(', ');
    });
    t = t.replace(/\u00A3(\d[\d,]*)(?:\.(\d\d))?/g, function (m, p, d) {
      var n = parseInt(p.replace(/,/g, ''), 10);
      return words(n) + (n === 1 ? ' pound' : ' pounds') + (d && d !== '00' ? ' ' + words(+d) : '');
    });
    t = t.replace(/\bBS EN\b/g, 'B S E N');
    t = t.replace(/\bPEEK\b/g, 'peek').replace(/\bPOM-?([CH])\b/g, 'P O M $1').replace(/\bPA\s?66\b/g, 'P A six six').replace(/\bPA\s?6\b/g, 'P A six')
      .replace(/\bNylon 66\b/gi, 'nylon six six').replace(/\bPE(\d{3,4})\b/g, function (m, n) { return 'P E ' + words(+n); }).replace(/\bRG(\d{3,4})\b/g, function (m, n) { return 'R G ' + words(+n); })
      .replace(/\bOD\s*[x×]\s*(?=\d)/g, 'outside diameter by ').replace(/\bOD\b/g, 'outside diameter').replace(/(\d\s*mm)\s*ID\b/g, '$1 inside diameter').replace(/Ø\s*/g, 'diameter ')
      .replace(/\bex VAT\b/gi, 'ex V A T').replace(/\binc\.? VAT\b/gi, 'including V A T').replace(/\bPLASTIC10\b/g, 'PLASTIC ten');
    t = t.replace(/\b(EPDM|HDPE|LDPE|UHMWPE|HMWPE|UHMW|PVC-U|PVC|PTFE|PVDF|PETG|PETP|PET|POM|PP|PPH|PPC|PU|UV|VAT|SBR|DDA|HIC|CFH|HGV|PSI|FDA|CNC)\b/g, function (m) { return m.replace('-', '').split('').join(' '); });
    t = t.replace(/\bLRV\b/g, 'L R V').replace(/\bPTV\b/g, 'P T V').replace(/\bLVT\b/g, 'L V T').replace(/\bGRP\b/g, 'G R P').replace(/\bDDA\b/g, 'D D A');
    t = t.replace(new RegExp(NUM + '\\s*m\u00B2', 'g'), function (m, n) { return numWords(n) + (parseFloat(n) === 1 ? ' square metre' : ' square metres'); });
    // 55 x 55mm, 2.7m x 3, 70x32mm
    t = t.replace(new RegExp(NUM + '\\s*(m|mm|cm)?\\s*[x\u00D7]\\s*' + NUM + '\\s*(m|mm|cm)?\\b', 'g'), function (m, a, ua, b, ub) {
      var u = ub || ua;
      return numWords(a) + ' by ' + numWords(b) + (u ? ' ' + UNIT[u] : '');
    });
    t = t.replace(new RegExp(NUM + '\\s*(gsm|mm|cm|kg|ft|m)\\b', 'g'), function (m, n, u) { return numWords(n) + ' ' + UNIT[u]; });
    t = t.replace(new RegExp(NUM + '\\s*%', 'g'), function (m, n) { return numWords(n) + ' percent'; });
    t = t.replace(new RegExp(NUM + '\\s*(?:-|\u2013)\\s*' + NUM, 'g'), function (m, a, b) { return numWords(a) + ' to ' + numWords(b); });
    t = t.replace(new RegExp(NUM, 'g'), function (m, n) { return numWords(n); });
    return t.replace(/\s+/g, ' ').trim();
  }
  function chunkText(text, max) {
    var parts = spoken(text).match(/[^.!?]+[.!?]*\s*/g) || [], out = [], cur = '';
    parts.forEach(function (p) { if ((cur + p).length > max && cur) { out.push(cur.trim()); cur = ''; } cur += p; });
    if (cur.trim()) out.push(cur.trim());
    return out;
  }

  // ---------- Voice out (Cloudflare TTS, British male voice; device voice as fallback) ----------
  var voiceOn = true, audioEl = null, playSeq = 0, audioUnlocked = false;
  // Ollie answers out loud only when the customer spoke to him (typed questions get a silent answer),
  // so nobody browsing at work or on a train is surprised by sound. voiceOn is the customer's mute switch.
  var spokeNext = false;
  var SILENT_WAV = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
  try { voiceOn = localStorage.getItem(VOICE_KEY) !== '0'; } catch (e) {}
  function ensureAudio() { if (!audioEl) { audioEl = new Audio(); audioEl.preload = 'auto'; audioEl.crossOrigin = 'anonymous'; } return audioEl; }
  // Echo cancellation, the way ChatGPT's voice does it. On a laptop Ollie's voice comes out of the speakers
  // and straight back into the mic, so he'd hear himself and "interrupt" his own sentence. The browser's
  // echo canceller only removes sound it knows is being played over a call (WebRTC), so on computers Ollie's
  // voice is sent through a WebRTC connection inside the page and played from that: the browser then
  // subtracts it from the microphone and only the customer's voice gets through. Phones already cancel
  // echo in hardware, so they keep the plain audio path. Any failure falls back to playing it directly.
  var aec = null;
  function aecSetup() {
    if (aec || !window.RTCPeerConnection || !(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    var ctx, src;
    try { ctx = new AC(); if (ctx.resume) ctx.resume(); src = ctx.createMediaElementSource(ensureAudio()); }
    catch (e) { aec = { failed: true }; return; }
    aec = { ctx: ctx, src: src };
    // How loud Ollie's own voice is right now, so the mic can be compared with it (see vmLoop).
    try { aec.an = ctx.createAnalyser(); aec.an.fftSize = 1024; aec.data = new Uint8Array(1024); src.connect(aec.an); } catch (e) { aec.an = null; }
    var direct = false;
    function playDirect() { if (!direct) { direct = true; try { src.connect(ctx.destination); } catch (e) {} } }
    try {
      var dest = ctx.createMediaStreamDestination(); src.connect(dest);
      var pc1 = new RTCPeerConnection(), pc2 = new RTCPeerConnection(), out = new Audio();
      out.autoplay = true;
      pc1.onicecandidate = function (e) { if (e.candidate) pc2.addIceCandidate(e.candidate).catch(function () {}); };
      pc2.onicecandidate = function (e) { if (e.candidate) pc1.addIceCandidate(e.candidate).catch(function () {}); };
      pc2.ontrack = function (e) { out.srcObject = e.streams[0]; var p = out.play(); if (p && p.catch) p.catch(playDirect); };
      dest.stream.getTracks().forEach(function (t) { pc1.addTrack(t, dest.stream); });
      pc1.createOffer().then(function (o) { return pc1.setLocalDescription(o); })
        .then(function () { return pc2.setRemoteDescription(pc1.localDescription); })
        .then(function () { return pc2.createAnswer(); })
        .then(function (a) { return pc2.setLocalDescription(a); })
        .then(function () { return pc1.setRemoteDescription(pc2.localDescription); })
        .catch(playDirect);
      aec.pc1 = pc1; aec.pc2 = pc2; aec.out = out;
      // Not connected within 3 seconds (a strict network policy, an old browser): play it directly instead.
      setTimeout(function () { if (pc2.connectionState !== 'connected' && pc2.iceConnectionState !== 'connected' && pc2.iceConnectionState !== 'completed') playDirect(); }, 3000);
    } catch (e) { playDirect(); }
  }
  function unlockAudio(force) {
    if (audioUnlocked || !(voiceOn || force) || !TTS_URL) return;
    var a = ensureAudio(); a.src = SILENT_WAV;
    var p = a.play();
    if (p && p.then) p.then(function () { audioUnlocked = true; }, function () {}); else audioUnlocked = true;
  }
  function stopVoice() {
    playSeq++;
    if (audioEl && String(audioEl.src).indexOf('data:') !== 0) { try { audioEl.pause(); } catch (e) {} }
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  }
  function speakDevice(text, onEnd) {
    if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) { if (onEnd) onEnd(); return; }
    var synth = window.speechSynthesis, vs = synth.getVoices() || [];
    var gb = vs.filter(function (v) { return /en[-_]GB/i.test(v.lang); });
    var voice = gb.filter(function (v) { return /male|Ryan|Thomas|George|Daniel|Arthur|Oliver|Google UK English Male/i.test(v.name); })[0] || gb[0] || null;
    synth.cancel();
    var parts = chunkText(text, 220);
    if (!parts.length && onEnd) onEnd();
    parts.forEach(function (c, i) {
      var u = new SpeechSynthesisUtterance(c); u.lang = 'en-GB'; if (voice) u.voice = voice; u.rate = 1.02; u.pitch = 0.95;
      if (onEnd && i === parts.length - 1) { u.onend = onEnd; u.onerror = onEnd; }
      synth.speak(u);
    });
  }
  function say(text) { if (!voiceOn || !text) return; stopVoice(); if (!TTS_URL) return speakDevice(text); var s = startStream(); s.feed(text, true); }
  // Speaks a reply while it streams: each finished sentence is queued and played in order.
  // onIdle (optional) fires once everything fed with final=true has finished playing (voice mode listens again then).
  function startStream(onIdle) {
    stopVoice();
    var seq = playSeq, a = ensureAudio(), queue = [], playing = false, taken = 0, finalFed = false, idleSent = false;
    function idle() { if (finalFed && !playing && !queue.length && !idleSent && seq === playSeq) { idleSent = true; if (onIdle) onIdle(); } }
    function playNext() {
      if (seq !== playSeq) return;
      var src = queue.shift();
      if (!src) { playing = false; idle(); return; }
      playing = true;
      var moved = false;
      function advance() { if (!moved) { moved = true; playNext(); } }
      a.onended = advance; a.onerror = advance; a.src = src;
      var pr = a.play(); if (pr && pr.catch) pr.catch(advance);
    }
    function enqueue(chunk) {
      chunkText(chunk, 600).forEach(function (t) { if (t) queue.push(TTS_URL + '?t=' + encodeURIComponent(t)); });
      if (!playing) playNext();
    }
    return {
      feed: function (visible, final) {
        if (seq !== playSeq || !(voiceOn || vmOn())) return;
        var rest = visible.slice(taken);
        if (!rest.trim()) { if (final) { finalFed = true; idle(); } return; }
        var cut = 0;
        if (final) cut = rest.length;
        else {
          var min = taken === 0 ? 30 : 140, re = /[.!?:](?=\s)|\n/g, m;
          while ((m = re.exec(rest))) { var end = m.index + 1; if (end > 600) break; if (end >= min) { cut = end; if (taken === 0) break; } }
        }
        if (cut > 0) { enqueue(rest.slice(0, cut)); taken += cut; }
        if (final) { finalFed = true; idle(); }
      }
    };
  }
  function setVoice(on, fromClick) {
    voiceOn = !!on;
    try { localStorage.setItem(VOICE_KEY, voiceOn ? '1' : '0'); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-ollie-voice]'), function (b) {
      b.setAttribute('aria-pressed', voiceOn ? 'true' : 'false');
      b.textContent = voiceOn ? 'Voice on' : 'Voice off';
      b.title = voiceOn ? 'When you talk to Ollie, he answers out loud. Tap to mute' : "Tap so Ollie answers out loud when you talk to him";
    });
    if (!voiceOn) { stopVoice(); return; }
    if (fromClick) { audioUnlocked = false; unlockAudio(); say("Voice is on. Tell me about the area you need to protect and I'll work out what you need."); track('voice_on', fromClick); }
  }

  // ---------- Voice in (talk button -> /stt). Waits for real speech and a proper pause before sending. ----------
  var rec = null;
  function micSupported() { return !!(STT_URL && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder); }
  var MIC_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';
  // The talk button: big and labelled, so nobody misses that they can just speak to Ollie.
  function talkButton(hint) {
    if (!micSupported()) return '';
    return '<button type="button" class="ollie-mic ollie-talk" aria-label="Tap to talk to Ollie">' +
      '<span class="ollie-talk__ic">' + MIC_SVG + '</span><span class="ollie-talk__txt">' +
      '<span class="ollie-talk__idle"><b class="ollie-talk__main">Tap to talk to Ollie</b><span class="ollie-talk__hint">' + hint + '</span></span>' +
      '<span class="ollie-talk__rec"><b class="ollie-talk__main">Listening\u2026 speak now</b><span class="ollie-talk__hint">Ollie sends it when you pause. Tap to stop.</span></span>' +
      '<span class="ollie-talk__busy"><b class="ollie-talk__main">Got it, one moment\u2026</b><span class="ollie-talk__hint">Ollie is working out your answer</span></span>' +
      '</span></button>';
  }
  function pickMime() {
    var c = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
    for (var i = 0; i < c.length; i++) if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(c[i])) return c[i];
    return '';
  }
  function note(inp, msg) {
    var ph = inp.getAttribute('data-ph') || inp.placeholder;
    inp.setAttribute('data-ph', ph); inp.value = ''; inp.placeholder = msg;
    clearTimeout(inp._phT);
    if (msg !== ph) inp._phT = setTimeout(function () { inp.placeholder = ph; }, 5000);
  }
  function startMic(f) {
    var inp = f.querySelector('input'), btn = f.querySelector('.ollie-mic');
    if (rec) { stopMic(); return; }
    stopVoice();
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } }).then(function (stream) {
      var mime = pickMime(), mr = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
      rec = { mr: mr, stream: stream, chunks: [], form: f, input: inp, btn: btn };
      mr.ondataavailable = function (e) { if (e.data && e.data.size) rec.chunks.push(e.data); };
      mr.onstop = finishMic;
      mr.start();
      btn.classList.add('is-rec'); btn.setAttribute('aria-label', 'Stop listening');
      note(inp, 'Listening\u2026 just speak, then pause');
      try {
        var AC = window.AudioContext || window.webkitAudioContext, ac = new AC(), an = ac.createAnalyser();
        an.fftSize = 1024; ac.createMediaStreamSource(stream).connect(an); rec.ac = ac;
        var data = new Uint8Array(an.fftSize), heard = false, started = Date.now(), quietSince = started, voiced = 0, last = started;
        (function loop() {
          if (!rec || rec.mr !== mr) return;
          an.getByteTimeDomainData(data);
          for (var sum = 0, i = 0; i < data.length; i++) { var v = (data[i] - 128) / 128; sum += v * v; }
          var now = Date.now();
          if (Math.sqrt(sum / data.length) > 0.04) { voiced += now - last; quietSince = now; }
          last = now;
          if (voiced >= 250) heard = true;
          if (!heard && now - started > 10000) { rec.silent = true; stopMic(); return; }
          if ((heard && now - quietSince > 2200) || now - started > 30000) { stopMic(); return; }
          requestAnimationFrame(loop);
        })();
      } catch (e) { rec.timer = setTimeout(stopMic, 15000); }
    }).catch(function () { note(inp, 'Microphone blocked. Allow it in your browser, or type your question'); });
  }
  function stopMic() { if (rec) { try { if (rec.mr.state !== 'inactive') rec.mr.stop(); } catch (e) {} } }
  function finishMic() {
    var r = rec; rec = null; if (!r) return;
    r.stream.getTracks().forEach(function (t) { t.stop(); });
    if (r.ac) { try { r.ac.close(); } catch (e) {} }
    clearTimeout(r.timer);
    r.btn.classList.remove('is-rec'); r.btn.setAttribute('aria-label', 'Tap to talk to Ollie');
    if (r.silent) { r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder; return; }
    r.btn.classList.add('is-busy'); note(r.input, 'Got it, one moment\u2026');
    var blob = new Blob(r.chunks, { type: r.mr.mimeType || 'audio/webm' });
    function done(text) {
      r.btn.classList.remove('is-busy');
      if (text === null) { note(r.input, "Sorry, I couldn't make that out. Could you type it?"); return; }
      if (!text) { note(r.input, "I didn't catch that. Tap to talk and try again"); return; }
      clearTimeout(r.input._phT); r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder; r.input.value = text;
      track('voice_ask', r.form.hasAttribute('data-ollie-pdp') ? 'pdp' : 'chat');
      spokeNext = true;
      if (r.form.hasAttribute('data-ollie-pdp')) pdpSubmit(r.form);
      else if (r.form.requestSubmit) r.form.requestSubmit(); else r.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
    if (blob.size < 1000) { done(''); return; }
    fetch(STT_URL, { method: 'POST', headers: { 'Content-Type': blob.type || 'audio/webm' }, body: blob })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) { done((j && j.text) || ''); })
      .catch(function () { done(null); });
  }

  // ---------- Streaming a reply from the Worker ----------
  // opts: { messages, product, el (bubble) }
  function streamReply(opts) {
    markCart('chatted');
    var talk = spokeNext || !!opts.vm; spokeNext = false;
    var speakOK = (voiceOn || !!opts.vm) && talk;
    var full = '', speech = speakOK && TTS_URL ? startStream(opts.onSpoken) : null;
    // Ollie sees the live basket with every message (added to this request only, never stored in the
    // conversation, so he always works from what's in it right now).
    return basketNote().then(function (note) {
      var msgs = opts.messages;
      // After the customer's words (the Worker keeps the first 2,000 characters, so a long basket can never cut
      // off what they asked).
      if (note) { msgs = msgs.slice(); var last = msgs[msgs.length - 1]; msgs[msgs.length - 1] = { role: last.role, content: last.content + '\n\n' + note }; }
      return fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(opts.product ? { messages: msgs, product: opts.product } : { messages: msgs }) });
    })
      .then(function (r) {
        if (!r.ok || !r.body) throw new Error('status ' + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder();
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) return;
            full += dec.decode(res.value, { stream: true });
            var vis = visibleText(full);
            if (vis) { opts.el.className = opts.el.className.replace(' ollie-typing', ''); opts.el.innerHTML = renderMd(vis); if (speech) speech.feed(vis, false); if (opts.onText) opts.onText(vis); }
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        if (!full.trim()) throw new Error('empty');
        if (speech) speech.feed(visibleText(full), true); else if (speakOK) speakDevice(visibleText(full), opts.onSpoken); else if (opts.onSpoken) opts.onSpoken();
        return full;
      })
      .catch(function (e) { if (speech) stopVoice(); throw e; });
  }

  // ---------- Chat window ----------
  function paint(who, html) {
    var el = document.createElement('div');
    el.className = 'ollie-msg ollie-msg--' + who; el.innerHTML = html;
    log.appendChild(el); log.scrollTop = log.scrollHeight;
    return el;
  }
  function bot(html) { history.push({ who: 'bot', html: html }); return paint('bot', html); }
  // Back from Shopify's "I'm not a robot" page: it returns here with ?contact_posted=true once the request is
  // sent. Reopen the chat with the confirmation (or, if the tick wasn't completed, say how to finish).
  function leadReturn() {
    var email = '';
    try { email = sessionStorage.getItem('ollie_lead_pending') || ''; } catch (e) {}
    if (!email) return;
    try { sessionStorage.removeItem('ollie_lead_pending'); } catch (e) {}
    var ok = /[?&]contact_posted=true/.test(location.search);
    open(null, 'lead_return');
    bot(ok ? '<div class="ollie-lead ollie-lead--done" role="status"><b>✓ Done: your exact price is on its way</b><small>It’ll be emailed to ' + esc(email) + ' the same working day (Mon–Fri). Just reply to that email to go ahead.</small></div>'
      : '<p>Your quote request didn’t finish sending. Tap “Email me my price” above to try again, or email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a>.</p>');
    if (ok) track('lead_sent', 'ollie');
    save();
  }
  function setChips(list) {
    chips.innerHTML = '';
    (list || []).forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ollie-chip'; b.textContent = c;
      b.addEventListener('click', function () { ask(c); });
      chips.appendChild(b);
    });
    save();
  }
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ c: convo.slice(-38), h: history.slice(-40), open: !panel.hidden })); } catch (e) {} }
  function restore() {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (!d || !d.h || !d.h.length) return false;
      convo = d.c || []; history = d.h;
      history.forEach(function (m) { paint(m.who, m.html); });
      return d.open;
    } catch (e) { return false; }
  }
  // The chat's first message is Claude's opener for this page (typing dots until it arrives);
  // the buttons under it are Claude's suggested questions for this page.
  var mainOpener = '';
  function welcome() {
    var el = paint('bot', '<span class="ollie-dots"><i></i><i></i><i></i></span>'); el.className += ' ollie-typing';
    pageOpener(9000).then(function (line) {
      if (convo.length || !el.parentNode) return;
      if (!line) { el.remove(); return; }
      mainOpener = line;
      el.className = el.className.replace(' ollie-typing', '');
      el.innerHTML = '<p>' + esc(line) + '</p>';
      history.push({ who: 'bot', html: el.innerHTML }); save();
    });
    suggestFor(productHandle(), function (qs) { if (!convo.length) setChips(qs); });
  }
  // vo (voice mode, optional): { vm: true, onText(visible), onSpoken() }. Returns a promise of the reply text (or null).
  function ask(text, vo) {
    text = String(text || '').trim();
    if (!text || busy) return Promise.resolve(null);
    if (!AI_URL) { bot('Our chat is offline right now. ' + TEAM); return Promise.resolve(null); }
    if (convo.length >= 38) convo = convo.slice(-20); // long chats keep their most recent context
    busy = true; unlockAudio();
    var userHtml = esc(text); history.push({ who: 'user', html: userHtml }); paint('user', userHtml);
    chips.innerHTML = '';
    var sent = text;
    if (!convo.length) {
      // Tell Ollie where they are and what he opened with, so a reply like "4 by 3, 80cm deep" makes sense.
      var pre = document.title ? '[Customer is on the page: ' + document.title.replace(/\s+/g, ' ').slice(0, 120) + ']\n' : '';
      if (mainOpener) pre += '[You opened the chat by saying: ' + mainOpener + ']\n';
      sent = pre + text;
    }
    var msgs = convo.concat([{ role: 'user', content: sent }]);
    var el = paint('bot', '<span class="ollie-dots"><i></i><i></i><i></i></span>'); el.className += ' ollie-typing';
    statusEl.textContent = 'Ollie is typing\u2026';
    var result = null;
    return streamReply({ messages: msgs, el: el, vm: vo && vo.vm, onText: vo && vo.onText, onSpoken: vo && vo.onSpoken }).then(function (full) {
      var out = renderReply(full, el);
      convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
      out.done.then(function () { history.push({ who: 'bot', html: el.innerHTML }); save(); log.scrollTop = log.scrollHeight; });
      setChips(out.chips || []);
      result = full;
    }).catch(function () {
      el.innerHTML = "<p>Sorry, I couldn't get an answer just now. " + TEAM + '</p>';
    }).then(function () { busy = false; statusEl.textContent = STATUS; save(); return result; });
  }
  function open(msg, source) {
    var wasHidden = panel.hidden;
    panel.hidden = false; launch.setAttribute('aria-expanded', 'true'); launch.classList.add('is-open');
    document.documentElement.classList.add('ollie-is-open');
    requestAnimationFrame(function () { panel.classList.add('is-in'); });
    if (!log.children.length) welcome();
    if (wasHidden) track(msg ? 'ask' : 'open', source);
    if (window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { input.focus(); }, 30);
    if (msg) ask(msg);
    save();
  }
  function close() {
    stopVoice(); if (rec) { rec.silent = true; stopMic(); }
    panel.classList.remove('is-in'); panel.hidden = true;
    launch.setAttribute('aria-expanded', 'false'); launch.classList.remove('is-open');
    document.documentElement.classList.remove('ollie-is-open');
    save();
  }
  function reset() { stopVoice(); convo = []; history = []; log.innerHTML = ''; chips.innerHTML = ''; welcome(); save(); }

  // Suggested questions written by the Worker for this page (cached at the edge).
  function suggestFor(handle, cb) {
    if (!BASE) return;
    var key = 'ollie_sg_' + (handle || '_home');
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && c.length) { cb(c); return; } } catch (e) {}
    fetch(BASE + '/suggest' + (handle ? '?product=' + encodeURIComponent(handle) : ''), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = j && j.questions;
        if (!list || list.length < 3) return;
        try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        cb(list);
      }).catch(function () {});
  }

  // ---------- Opening lines: always written by Claude (worker /opener), never pre-set ----------
  // Product pages get a line written from that product's details; every other page gets one written
  // for that page. Cached per page for the visit. Resolves to '' if Claude can't be reached in time,
  // in which case Ollie says nothing scripted and simply waits for the customer.
  var openerJobs = {};
  function pageOpener(timeoutMs) {
    var h = productHandle();
    var q = h ? 'product=' + encodeURIComponent(h)
      : 'page=' + encodeURIComponent(location.pathname) + '&title=' + encodeURIComponent((document.title || '').replace(/\s+/g, ' ').slice(0, 140));
    var key = 'ollie_op_' + (h || location.pathname);
    if (!openerJobs[key]) {
      openerJobs[key] = new Promise(function (resolve) {
        try { var c = sessionStorage.getItem(key); if (c) { resolve(c); return; } } catch (e) {}
        if (!BASE) { resolve(''); return; }
        fetch(BASE + '/opener?' + q, { mode: 'cors' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var line = j && typeof j.opener === 'string' ? j.opener.trim() : '';
            if (line) { try { sessionStorage.setItem(key, line); } catch (e) {} }
            resolve(line);
          }).catch(function () { resolve(''); });
      });
    }
    if (!timeoutMs) return openerJobs[key];
    return Promise.race([openerJobs[key], new Promise(function (r) { setTimeout(function () { r(''); }, timeoutMs); })]);
  }
  // ---------- "Questions about this product?" box on product pages ----------
  var PDP = null;
  function productHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function pdpChip(q) { return '<button type="button" class="ollie-e__chip" data-ollie-ask="' + esc(q) + '">' + esc(q) + '</button>'; }
  function pdpSave() { try { sessionStorage.setItem('ollie_pdp_v2_' + PDP.handle, JSON.stringify({ c: PDP.convo.slice(-30), h: PDP.thread.innerHTML, ch: PDP.chips.innerHTML })); } catch (e) {} }
  function pdpSubmit(f) {
    var inp = f.querySelector('input'), q = inp && inp.value.trim();
    if (!q) { if (inp) inp.focus(); return; }
    inp.value = ''; pdpAsk(q);
  }
  function pdpAsk(q, vo) {
    if (!PDP || PDP.busy || !q) return Promise.resolve(null);
    if (!AI_URL) { open(q, 'pdp'); return Promise.resolve(null); }
    if (PDP.convo.length >= 38) { PDP.convo = []; PDP.thread.innerHTML = ''; }
    PDP.busy = true; unlockAudio(); track('ask', 'pdp-expert');
    var userEl = document.createElement('div'); userEl.className = 'ollie-e__msg ollie-e__msg--user'; userEl.innerHTML = esc(q); PDP.thread.appendChild(userEl);
    var el = document.createElement('div'); el.className = 'ollie-e__msg ollie-e__msg--bot ollie-typing'; el.innerHTML = '<span class="ollie-dots"><i></i><i></i><i></i></span>'; PDP.thread.appendChild(el);
    // Scroll inside the card, not the page: show the question at the top with the answer streaming under it.
    PDP.thread.scrollTop = Math.max(0, userEl.offsetTop - 6);
    var first = !PDP.convo.length && PDP.opener ? '[You opened by saying: ' + PDP.opener + ']\n' + q : q;
    var msgs = PDP.convo.concat([{ role: 'user', content: first }]);
    var result = null;
    return streamReply({ messages: msgs, product: PDP.handle, el: el, vm: vo && vo.vm, onText: vo && vo.onText, onSpoken: vo && vo.onSpoken }).then(function (full) {
      var out = renderReply(full, el);
      PDP.convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
      if (out.chips && out.chips.length) PDP.chips.innerHTML = out.chips.map(pdpChip).join('');
      out.done.then(pdpSave);
      result = full;
    }).catch(function () {
      el.innerHTML = "<p>Sorry, I couldn't get an answer just now. " + TEAM + '</p>';
    }).then(function () { PDP.busy = false; return result; });
  }
  function mountProductBox() {
    var handle = productHandle();
    if (!handle || document.querySelector('.ollie-e--pdp')) return;
    // Dawn renders a hidden "installment" form before the real one, so prefer the add-to-cart form.
    var buy = document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment):not([data-ollie-skip])');
    if (!buy) return;
    // Sit straight under the buy buttons, outside the theme's <product-form> so the box's input and
    // buttons never reach the cart code.
    var anchor = buy.closest('product-form') || buy;
    // Compact card: who Ollie is, a friendly opener, one text field (with a small mic inside) and three
    // short starter questions. The conversation scrolls inside the card so the page doesn't jump.
    var box = document.createElement('section');
    box.className = 'ollie-e ollie-e--pdp';
    box.setAttribute('aria-label', 'Ask Ollie about this product');
    // Voice is the easiest way in, so the mic is a labelled "Talk" button, not a small icon in the field.
    var mic = micSupported() ? '<button type="button" class="ollie-mic ollie-e__mic" aria-label="Talk to Ollie" title="Talk to Ollie">' + MIC_SVG + '<span>Talk</span></button>' : '';
    box.innerHTML = '<div class="ollie-e__head"><span class="ollie-e__av" aria-hidden="true">O<i></i></span>' +
      '<div class="ollie-e__who"><b>Ollie</b><span class="ollie-e__ai">AI</span><small>Matting specialist \u00b7 replies in seconds</small></div></div>' +
      '<div class="ollie-e__thread" aria-live="polite"><div class="ollie-e__msg ollie-e__msg--bot ollie-e__greet"><span class="ollie-dots"><i></i><i></i><i></i></span></div></div>' +
      '<div class="ollie-e__form" data-ollie-pdp><div class="ollie-e__field">' +
      '<input type="text" enterkeyhint="send" maxlength="1000" placeholder="Type your question\u2026" aria-label="Ask Ollie a question about this product"></div>' +
      mic + '<button type="button" class="ollie-e__send" data-ollie-pdp-send>Send</button></div>' +
      '<div class="ollie-e__chips">' + ['Is it right for my job?', 'How many do I need?', 'What else do I need?'].map(pdpChip).join('') + '</div>';
    // Placement (conversion): straight after the buy block and its trust panel ("Faulty or damaged?..."), so a
    // shopper who hesitates at Add to basket sees Ollie next, above the highlights, key specs and the "Trade,
    // bulk or need advice?" panel. Falls back to under the whole buy form on other layouts.
    var info = buy.closest('.emx-pdp__info, .emx-info');
    var after = info && (info.querySelector('.emx-block--trust') || info.querySelector('.emx-block--buy'));
    if (after && after.offsetParent !== null) {
      after.parentNode.insertBefore(box, after.nextSibling);
      // The product column orders its blocks with CSS flex "order" (2, 4, 6...): take the slot right after.
      var ord = parseInt(getComputedStyle(after).order, 10);
      if (ord) box.style.order = String(ord + 1);
    }
    else anchor.parentNode.insertBefore(box, anchor.nextSibling);
    document.documentElement.classList.add('ollie-has-pdp');
    pdpHooks(buy, box);
    PDP = { box: box, handle: handle, thread: box.querySelector('.ollie-e__thread'), chips: box.querySelector('.ollie-e__chips'), convo: [], busy: false };
    try {
      var d = JSON.parse(sessionStorage.getItem('ollie_pdp_v2_' + handle) || 'null');
      if (d && d.c) { PDP.convo = d.c; PDP.thread.innerHTML = d.h || ''; if (d.ch) PDP.chips.innerHTML = d.ch; }
    } catch (e) {}
    // Starter questions written for this product (with real sizes and jobs), replacing the general ones.
    suggestFor(handle, function (qs) { if (PDP && !PDP.convo.length && qs && qs.length) PDP.chips.innerHTML = qs.slice(0, 3).map(pdpChip).join(''); });
    loadOpener(handle);
  }
  // The page's own "ask" links go to Ollie first, where shoppers hesitate: "Not sure which? Ask an expert" by the
  // size options, and the quote/advice buttons in the "Trade, bulk or need advice?" panel (all marked
  // data-emx-quote-open by the theme; advice mode opens Ollie ready to type, quote mode asks him to price it).
  // Capture phase, so the theme's own popup never opens for them.
  function pdpHooks(buy, box) {
    function goBox(q) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (q) pdpAsk(q); else { var i = box.querySelector('input'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 400); }
    }
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-emx-quote-open]');
      if (!el || box.contains(el)) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var mode = el.getAttribute('data-emx-quote-mode') || '';
      track(mode === 'advice' ? 'advice_to_ollie' : 'quote_to_ollie', 'pdp');
      goBox(mode === 'advice' ? '' : 'I need a bulk quantity, a custom size or trade pricing. Can you price it?');
    }, true);
  }
  // Ollie's opening line for this product, written by Claude from the product's own details (cached at the
  // edge per product). The built-in line shows instantly; this replaces it as soon as it arrives.
  function loadOpener(handle) {
    pageOpener(9000).then(function (line) {
      if (!PDP || PDP.handle !== handle) return;
      var g = PDP.thread.querySelector('.ollie-e__greet');
      if (!line) { if (g && !PDP.convo.length) g.remove(); return; }
      PDP.opener = line;
      if (g && !PDP.convo.length) g.textContent = line;
    });
  }

  // ---------- Voice mode: a hands-free spoken conversation (tap once, then just talk) ----------
  // Listens, notices when the customer stops talking, sends it, Ollie answers out loud (captions,
  // product cards and Add to basket appear as he talks), then listens again. Talking while Ollie is
  // speaking interrupts him. One microphone stream for the whole conversation, so no repeated prompts.
  var VM = null, vmEl = null;
  var KEY_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10"/></svg>';
  var END_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var MUTE_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 2l20 20M9 9v3a3 3 0 0 0 5.1 2.1M15 9.3V5a3 3 0 0 0-5.9-.7M5 10a7 7 0 0 0 11.9 5M19 10a7 7 0 0 1-.4 2.3M12 17v5M8 22h8"/></svg>';
  var VM_TEXT = { listening: 'Listening…', hearing: 'Listening…', thinking: 'Thinking…', speaking: 'Ollie is talking · just speak to interrupt', paused: 'Paused · tap the circle to talk', muted: 'Your mic is off · tap “Mic off” to turn it on' };
  function vmOn() { return !!(VM && VM.active); }
  function vmBuild() {
    if (vmEl) return vmEl;
    vmEl = document.createElement('div');
    vmEl.className = 'ollie-vm'; vmEl.hidden = true;
    vmEl.setAttribute('role', 'dialog'); vmEl.setAttribute('aria-modal', 'true'); vmEl.setAttribute('aria-label', 'Voice conversation with Ollie');
    // The store's own brand leads (white logo + domain), with Ollie as its assistant under it.
    // The logo's URL comes from the snippet (data-logo: the theme asset), so it follows the theme.
    var logo = panel.getAttribute('data-logo') || '';
    vmEl.innerHTML = '<div class="ollie-vm__top"><div class="ollie-vm__brand">' + (logo ? '<img src="' + esc(logo) + '" alt="Express Matting" width="148" height="50" onerror="this.replaceWith(Object.assign(document.createElement(\'b\'),{textContent:\'Express Matting\'}))">' : '<b>Express Matting</b>') +
      '<small>expressmatting.co.uk · Free UK delivery · Cut to your length</small></div>' +
      '<button type="button" class="ollie-vm__x" data-vm-end aria-label="End voice chat">' + END_SVG + '</button></div>' +
      '<div class="ollie-vm__who"><span class="ollie-vm__av" aria-hidden="true">O<i></i></span><b>Ollie</b><small>AI matting specialist · voice chat</small></div>' +
      '<div class="ollie-vm__stage"><button type="button" class="ollie-vm__orb" data-vm-orb aria-label="Tap to talk, or to interrupt Ollie"><i></i><i></i><i></i><b></b></button>' +
      '<div class="ollie-vm__state" aria-live="polite"></div></div>' +
      '<div class="ollie-vm__shelf" aria-label="Products in this conversation"></div>' +
      '<div class="ollie-vm__caps" aria-live="polite"></div>' +
      '<div class="ollie-vm__chips"></div>' +
      '<div class="ollie-vm__bar"><button type="button" class="ollie-vm__btn" data-vm-mute aria-pressed="false"><span class="ollie-vm__ic">' + MIC_SVG + '</span><span class="ollie-vm__lb">Mic on</span></button>' +
      '<button type="button" class="ollie-vm__btn" data-vm-type><span class="ollie-vm__ic">' + KEY_SVG + '</span><span class="ollie-vm__lb">Type instead</span></button>' +
      '<button type="button" class="ollie-vm__btn ollie-vm__btn--end" data-vm-end><span class="ollie-vm__ic">' + END_SVG + '</span><span class="ollie-vm__lb">End</span></button></div>';
    document.body.appendChild(vmEl);
    vmEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-vm-end]')) { vmEnd(); return; }
      if (e.target.closest('[data-vm-type]')) { vmEnd(true); return; }
      if (e.target.closest('[data-vm-mute]')) { vmMute(!VM.muted); return; }
      if (e.target.closest('[data-vm-orb]')) { vmOrb(); return; }
      var c = e.target.closest('[data-vm-chip]');
      if (c) { vmInterruptAndSend(c.getAttribute('data-vm-chip')); return; }
    });
    return vmEl;
  }
  function vmSet(state, text) {
    if (!VM) return;
    if (state === 'speaking' && VM.state !== 'speaking') VM.lastAudioT = Date.now(); // give his voice time to start
    VM.state = state;
    vmEl.setAttribute('data-state', state);
    var msg = text || VM_TEXT[state] || '';
    // Laptops and desktops (a mouse, no touch): mention the Space bar.
    if (!text && (state === 'speaking' || state === 'hearing') && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)
      msg += state === 'speaking' ? ' (or press Space)' : ' · press Space to send';
    vmEl.querySelector('.ollie-vm__state').textContent = msg;
  }
  // The shelf: the product they're viewing, then up to 3 products Ollie has suggested (newest first), so
  // the voice screen stays connected to the shop and everything discussed is one tap away. A quoted size
  // shows that size and price, and opens the product with that size selected.
  function vmShelfAdd(it, viewing) {
    if (!vmEl || !it || !it.h) return;
    var shelf = vmEl.querySelector('.ollie-vm__shelf');
    getProduct(it.h).then(function (p) {
      if (!vmEl || !p) return;
      // Name: the part before the marketing extras ("EPDM Pond Liner UK | 1.0mm Heavy Duty | Fish Safe..."
      // becomes "EPDM Pond Liner UK · 1.0mm Heavy Duty").
      var name = String(p.title).split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 2).join(' · ');
      var size = it.v && it.v.title && it.v.title !== 'Default Title' ? it.v.title.replace(/\s*\/\s*/g, ' · ') : '';
      var price = it.v ? money(it.v.price) : (p.price_min !== p.price_max ? 'From ' + money(p.price_min) : money(p.price_min));
      var meta = '<span class="ollie-vm__meta">' + (size ? '<span class="ollie-vm__sz">' + esc(size) + '</span>' : '') + '<span class="ollie-vm__pr">' + price + '</span></span>';
      var href = '/products/' + encodeURIComponent(p.handle) + (it.id ? '?variant=' + it.id : '');
      var qty = Math.max(1, parseInt(it.q, 10) || 1);
      // A compact button (basket icon + "Add"), so the product name gets the room; the full wording is its label.
      var add = it.v && it.v.available && it.v.price > 0 ? '<button type="button" class="ollie-add ollie-vm__add" data-v="' + esc(it.id) + '" data-q="' + qty + '" data-h="' + esc(p.handle) + '" aria-label="Add ' + (qty > 1 ? qty + ' ' : '') + 'to basket" title="Add ' + (qty > 1 ? qty + ' ' : '') + 'to basket">' + BASKET_SVG + '<span>Add' + (qty > 1 ? ' ' + qty : '') + '</span></button>' : '';
      var tiles = [].slice.call(shelf.children), same = tiles.filter(function (t) { return t.getAttribute('data-h') === p.handle; })[0];
      // Ollie quoting the product they're already viewing: update that card rather than adding a second one.
      if (same && same.classList.contains('is-viewing') && !viewing) {
        same.querySelector('a').href = href; same.querySelector('.ollie-vm__meta').outerHTML = meta;
        var old = same.querySelector('.ollie-vm__add'); if (old) old.remove();
        if (add) same.insertAdjacentHTML('beforeend', add);
        return;
      }
      if (same) same.remove();
      var img = p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="ollie-vm__ph"></span>';
      var html = '<div class="ollie-vm__item' + (viewing ? ' is-viewing' : '') + '" data-h="' + esc(p.handle) + '"><a class="ollie-vm__lnk" href="' + esc(href) + '" title="' + esc(p.title) + '">' + img +
        '<span class="ollie-vm__it"><small>' + (viewing ? 'You’re viewing' : 'Ollie suggests') + '</small><b>' + esc(name) + '</b>' + meta + '</span></a>' + add + '</div>';
      var first = shelf.querySelector('.is-viewing');
      if (viewing || !first) shelf.insertAdjacentHTML('afterbegin', html); else first.insertAdjacentHTML('afterend', html);
      var extra = shelf.querySelectorAll('.ollie-vm__item:not(.is-viewing)');
      for (var i = 3; i < extra.length; i++) extra[i].remove();
      shelf.scrollLeft = 0;
      if (!shelf._more) { shelf._more = true; shelf.addEventListener('scroll', shelfMore, { passive: true }); }
      shelfMore();
    }).catch(function () {});
  }
  var BASKET_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6"/><circle cx="10" cy="20.5" r="1.2"/><circle cx="17" cy="20.5" r="1.2"/></svg>';
  function vmCaption(who, html) {
    var caps = vmEl.querySelector('.ollie-vm__caps');
    var el = document.createElement('div');
    el.className = 'ollie-vm__cap ollie-vm__cap--' + who; el.innerHTML = html;
    caps.appendChild(el);
    while (caps.children.length > 12) caps.removeChild(caps.firstChild);
    caps.scrollTop = caps.scrollHeight;
    return el;
  }
  function vmChips(list) {
    vmEl.querySelector('.ollie-vm__chips').innerHTML = (list || []).slice(0, 3).map(function (c) {
      return '<button type="button" class="ollie-vm__chip" data-vm-chip="' + esc(c) + '">' + esc(c) + '</button>';
    }).join('');
  }
  function vmStart(ctx) {
    if (vmOn()) return;
    if (!micSupported()) {
      if (ctx === 'pdp' && PDP) PDP.box.querySelector('input').focus(); else { open(null, 'talk'); input.focus(); }
      return;
    }
    stopVoice(); if (rec) { rec.silent = true; stopMic(); }
    unlockAudio(true);
    aecSetup();
    // The level meter's AudioContext is created inside the tap: iPhones keep it silent otherwise.
    var ac = null;
    try { var AC = window.AudioContext || window.webkitAudioContext; ac = new AC(); if (ac.resume) ac.resume(); } catch (e) { ac = null; }
    vmBuild();
    VM = { active: true, ctx: ctx === 'pdp' && PDP ? 'pdp' : 'chat', state: '', stream: null, mr: null, chunks: [], muted: false, turns: 0, barge: 0, last: 0, debug: /olliedebug/.test(location.hash + location.search) };
    vmEl.querySelector('.ollie-vm__caps').innerHTML = '';
    vmEl.querySelector('.ollie-vm__shelf').innerHTML = '';
    vmEl.classList.remove('is-talking');
    if (productHandle()) vmShelfAdd({ h: productHandle() }, true);
    vmChips([]);
    vmMuteUi();
    vmEl.hidden = false; document.documentElement.classList.add('ollie-vm-open');
    requestAnimationFrame(function () { vmEl.classList.add('is-in'); });
    vmSet('thinking', 'Starting the microphone…');
    track('voice_mode', VM.ctx);
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true } }).then(function (stream) {
      if (!vmOn()) { stream.getTracks().forEach(function (t) { t.stop(); }); if (ac) { try { ac.close(); } catch (e) {} } return; }
      VM.stream = stream;
      try {
        VM.ac = ac; if (VM.ac.state === 'suspended' && VM.ac.resume) VM.ac.resume();
        VM.an = VM.ac.createAnalyser(); VM.an.fftSize = 1024;
        VM.ac.createMediaStreamSource(stream).connect(VM.an);
        VM.data = new Uint8Array(VM.an.fftSize);
      } catch (e) {}
      VM.calibUntil = Date.now() + 500;
      // A plain timer (not requestAnimationFrame): phones slow or pause animation frames in low-power
      // mode or while the screen dims, which would stop Ollie noticing when you speak.
      VM.timer = setInterval(vmLoop, 40);
      setTimeout(function () { if (vmOn()) vmGreet(); }, 550);
    }).catch(function () {
      vmSet('paused', 'Your microphone is blocked. Allow it in your browser, or tap “Type instead”.');
    });
  }
  // A short spoken hello the first time on each page, then straight to listening.
  function vmGreet() {
    var key = 'ollie_vm_hi_' + location.pathname, seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (e) {}
    if (seen || !TTS_URL) { vmListen(); return; }
    vmSet('thinking', '');
    pageOpener(3500).then(function (hi) {
      if (!vmOn()) return;
      if (!hi) { vmListen(); return; }
      if (VM.ctx !== 'pdp' && !convo.length) mainOpener = hi; // so Ollie knows what he asked
      VM.said = hi;
      vmCaption('bot', '<p>' + esc(hi) + '</p>');
      vmSet('speaking'); VM.speakT0 = Date.now();
      var s = startStream(function () { if (vmOn() && VM.state === 'speaking') vmAfterSpeech(); });
      s.feed(hi, true);
    });
  }
  function vmOutLevel() {
    if (!aec || !aec.an) return null;
    aec.an.getByteTimeDomainData(aec.data);
    for (var sum = 0, i = 0; i < aec.data.length; i++) { var v = (aec.data[i] - 128) / 128; sum += v * v; }
    return Math.sqrt(sum / aec.data.length);
  }
  function vmLevel() {
    if (!VM.an) return 0;
    VM.an.getByteTimeDomainData(VM.data);
    for (var sum = 0, i = 0; i < VM.data.length; i++) { var v = (VM.data[i] - 128) / 128; sum += v * v; }
    return Math.sqrt(sum / VM.data.length);
  }
  // Starts recording a turn. quiet = true while Ollie is still talking (a possible interruption);
  // msg replaces the usual "Listening…" line.
  function vmListen(quiet, msg) {
    if (!vmOn() || !VM.stream) return;
    if (VM.muted) { vmSet('muted'); return; }
    if (VM.mr) return;
    var mime = pickMime(), mr;
    try { mr = mime ? new MediaRecorder(VM.stream, { mimeType: mime }) : new MediaRecorder(VM.stream); }
    catch (e) { vmSet('paused', 'Voice isn’t available in this browser. Tap “Type instead”.'); return; }
    VM.mr = mr; VM.chunks = []; VM.heard = false; VM.voiced = 0; VM.t0 = Date.now(); VM.quietT = Date.now(); VM.discard = false; VM.pending = !!quiet; VM.hinted = false; VM.peak = 0;
    mr.ondataavailable = function (e) { if (e.data && e.data.size && VM) VM.chunks.push(e.data); };
    mr.onstop = function () { vmTurnEnded(mr); };
    mr.start(250);
    if (!quiet) vmSet('listening', msg);
  }
  // Ollie has finished (or was cut off): listen. If the customer had already started talking over him,
  // keep that recording as their turn rather than starting a fresh one.
  function vmAfterSpeech() {
    if (!vmOn()) return;
    if (VM.mr && VM.pending) {
      VM.pending = false; VM.voiced = VM.barge; VM.heard = VM.barge > 200; VM.barge = 0;
      VM.t0 = Date.now(); VM.quietT = Date.now();
      vmSet(VM.heard ? 'hearing' : 'listening');
      return;
    }
    vmListen();
  }
  function vmStopRec(discard) {
    if (!VM || !VM.mr) return;
    if (discard) VM.discard = true;
    try { if (VM.mr.state !== 'inactive') VM.mr.stop(); } catch (e) {}
  }
  // Milliseconds since Ollie's voice was last actually playing (audio element or the device voice).
  function vmSilentFor(now) {
    var playing = (audioEl && !audioEl.paused && !audioEl.ended && String(audioEl.src).indexOf('data:') !== 0) ||
      (window.speechSynthesis && window.speechSynthesis.speaking);
    if (playing || VM.lastAudioT == null) VM.lastAudioT = now;
    return now - VM.lastAudioT;
  }  function vmLoop() {
    if (!vmOn()) return;
    var lvl = vmLevel(), now = Date.now(), dt = VM.last ? Math.min(100, now - VM.last) : 16;
    VM.last = now;
    vmEl.style.setProperty('--lvl', Math.min(1, lvl * 7).toFixed(3));
    // Speech is judged against this phone's own background level (noise suppression and auto gain make
    // voices much quieter on some phones than others), never a fixed loudness. The background estimate
    // falls fast and rises slowly, so it can't get stuck at zero; and once they've started talking, the
    // end of speech is judged against how loud they actually were, so steady room noise (a fan, a TV)
    // can't keep Ollie listening forever.
    VM.sl = VM.sl == null ? lvl : VM.sl * 0.7 + lvl * 0.3;
    var sl = VM.sl;
    // The first half second after the microphone opens (before Ollie says hello) measures the room: the
    // quietest level heard becomes the background, so nobody talking early can fool it.
    var calibrating = now < (VM.calibUntil || 0);
    if (calibrating) {
      VM.calMin = VM.calMin == null ? sl : Math.min(VM.calMin, sl);
      VM.floor = Math.min(Math.max(VM.calMin, 0.002), 0.05);
    } else if (VM.state !== 'speaking' && VM.state !== 'thinking') {
      if (VM.floor == null) VM.floor = Math.max(sl, 0.002);
      else if (sl < VM.floor) VM.floor = VM.floor * 0.9 + sl * 0.1;
      else VM.floor = VM.floor * 0.998 + sl * 0.002;
      VM.floor = Math.min(Math.max(VM.floor, 0.002), 0.05);
    }
    var thr = Math.max(0.006, (VM.floor || 0.004) * 2.2);
    if (VM.debug) vmEl.querySelector('.ollie-vm__state').textContent = (VM.state || '') + ' lvl ' + sl.toFixed(3) + ' floor ' + (VM.floor || 0).toFixed(3) + ' thr ' + thr.toFixed(3) + ' peak ' + (VM.peak || 0).toFixed(3) + ' echo ' + (VM.echo || 0).toFixed(3) + ' leak ' + (VM.leak == null ? '-' : VM.leak.toFixed(2)) + (aec && aec.an ? ' aec' : ' noaec') + ' you ' + (VM.userPeak || 0).toFixed(3) + ' bthr ' + (VM.bthr || 0).toFixed(3) + (VM.heard ? ' HEARD' : '');
    // Half a sentence is waiting ("…for a pond that's") and they've stayed quiet: send what we have.
    if (VM.partial && !VM.stt && !(VM.mr && VM.heard) && now - (VM.partialT || 0) > 2500 &&
        VM.state !== 'speaking' && VM.state !== 'thinking') { vmFlush(); return; }
    if (VM.mr && !VM.pending && (VM.state === 'listening' || VM.state === 'hearing')) {
      var speechNow = !calibrating && sl > thr && (!VM.heard || sl > (VM.peak || 0) * 0.2);
      if (speechNow) { VM.voiced += dt; VM.quietT = now; if (VM.heard) VM.peak = Math.max((VM.peak || 0) * 0.999, sl); }
      if (VM.voiced >= 200 && !VM.heard) { VM.heard = true; VM.peak = sl; if (!VM.debug) vmSet('hearing', 'Listening… tap the circle when you’ve finished'); else VM.state = 'hearing'; }
      if (VM.heard && now - VM.quietT > 1200) {
        // Remember how loud this customer talks: it's how Ollie recognises them talking over him later.
        VM.userPeak = VM.userPeak ? VM.userPeak * 0.5 + (VM.peak || 0) * 0.5 : (VM.peak || 0);
        vmStopRec();
      }
      else if (!VM.heard && now - VM.t0 > 6000 && !VM.hinted) { VM.hinted = true; if (!VM.debug) vmSet('listening', 'Listening… speak, then tap the circle to send'); }
      else if (!VM.heard && now - VM.t0 > 30000) { VM.idleStop = true; vmStopRec(); }
      else if (now - VM.t0 > 30000) vmStopRec();    } else if (VM.state === 'speaking' && now - (VM.speakT0 || 0) > 700 && (vmSilentFor(now) > 4000 || now - (VM.speakT0 || 0) > 60000)) {
      // Safety net: nothing has actually played for 4 seconds, so Ollie has finished (some phones never
      // report the end of the audio once the microphone is on). Listen.
      vmAfterSpeech();
    } else if (VM.state === 'speaking' && !VM.muted) {
      // Interrupting Ollie (like ChatGPT voice): talk over him and he stops. Some of his own voice always
      // leaks back into the mic (less on computers, where the echo canceller removes most of it). On
      // computers Ollie measures his own voice as it plays and learns how much of it reaches the mic, so at
      // every moment he knows how loud "just me" should be: clearly louder than that is the customer. On
      // phones (hardware echo cancelling) he compares with the loudest his voice gets in the mic, once he
      // has heard the customer speak. Space or a tap always stops him too.
      var outLvl = vmOutLevel(), bthr;
      if (outLvl != null) {
        // His voice over the last ~0.5s: the mic hears it a moment after it leaves him (the echo-cancelling
        // connection and the speakers each add a little delay).
        VM.outHist = VM.outHist || []; VM.outHist.push(outLvl); if (VM.outHist.length > 12) VM.outHist.shift();
        var outNow = Math.max.apply(null, VM.outHist);
        // Learn the leak (mic level / his level) only from moments that look like plain echo, never while
        // the customer may be talking (otherwise their voice would be learned as "echo" and they could
        // never get a word in). A steady average, kept between turns.
        if (VM.barge === 0 && outNow > 0.02) {
          var leak = sl / outNow;
          if (VM.leak == null) {
            // First ~20 measurements (under a second of him talking): take a high-but-typical value.
            VM.leakS = VM.leakS || []; VM.leakS.push(leak);
            if (VM.leakS.length >= 20) { var srt = VM.leakS.slice().sort(function (a, b) { return a - b; }); VM.leak = srt[Math.floor(srt.length * 0.8)]; }
          } else if (leak < VM.leak * 1.8) VM.leak = VM.leak * 0.97 + leak * 0.03;
        }
        bthr = Math.max(thr * 2.5, (VM.leak == null ? 0.5 : VM.leak) * outNow * 2 + thr, 0.012);
      } else {
        if (VM.barge === 0) VM.echo = Math.max((VM.echo || 0) * 0.99, sl);
        bthr = Math.max(thr * 2, (VM.echo || 0) * 1.5, (VM.userPeak || 0) * 0.45, 0.012);
      }
      VM.bthr = bthr;
      // Voice interruptions start once the customer has spoken to him (so never during the greeting, while the
      // browser's echo canceller is still settling) and not in the first 1.5s of any reply. Space or a tap always works.
      if (VM.userPeak && (outLvl == null || VM.leak != null) && now - (VM.speakT0 || 0) > 1500) {
        if (sl > bthr) { if (!VM.mr) vmListen(true); VM.barge += dt; } else VM.barge = Math.max(0, VM.barge - dt / 2);
        if (VM.barge > 350) {
          VM.barge = 0; VM.bargeTurn = true; stopVoice(); track('voice_interrupt', VM.ctx);
          VM.pending = false; VM.heard = true; VM.voiced = 400; VM.quietT = now; VM.peak = sl; vmSet('hearing', 'Go ahead, I’m listening…');
        } else if (VM.mr && VM.pending && VM.barge === 0 && now - VM.t0 > 1500) vmStopRec(true);
      }
    }
  }
  function vmTurnEnded(mr) {
    if (!VM || VM.mr !== mr) return;
    VM.mr = null;
    var chunks = VM.chunks; VM.chunks = [];
    if (!vmOn()) return;
    if (VM.discard || VM.pending) { VM.discard = false; VM.pending = false; return; }
    if (VM.idleStop) { VM.idleStop = false; if (VM.partial && !VM.stt) { vmFlush(); return; } vmSet('paused'); return; }
    var blob = new Blob(chunks, { type: mr.mimeType || 'audio/webm' });
    if (!VM.heard || blob.size < 1200) {
      if (VM.flushReq && VM.partial && !VM.stt) { vmFlush(); return; }
      if (!VM.stt) VM.flushReq = false;
      vmListen(); return;
    }
    // People pause mid-sentence ("a pond that's… 10 by 9"). So the microphone keeps recording while this
    // part is transcribed, the parts are joined in order, and the question is only sent once it sounds
    // finished (or they've gone quiet for a moment, or tapped to send).
    VM.stt = (VM.stt || 0) + 1;
    var part = fetch(STT_URL, { method: 'POST', headers: { 'Content-Type': blob.type || 'audio/webm' }, body: blob })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) { return ((j && j.text) || '').trim(); }, function () { return null; });
    VM.sttQ = (VM.sttQ || Promise.resolve()).then(function () { return part; }).then(vmGotText);
    vmListen(false, VM.flushReq ? 'Got it…' : 'Listening…');
  }
  function vmGotText(text) {
    if (!vmOn()) return;
    VM.stt--;
    if (text) VM.partial = VM.partial ? VM.partial + ' ' + text : text;
    VM.partialT = Date.now();
    if (VM.stt) return;                                   // another part is still being transcribed
    // After an interruption, a lone filler ("All right.", "Thank you.") is almost always Ollie's own voice
    // picked up by the mic, not the customer: drop it and just listen.
    if (VM.bargeTurn && VM.partial && (/^(all ?right|okay|ok|yeah|yes|yep|right|thank you|thanks|you|bye|hmm|um|uh|so|oh)[\s.,!?]*$/i.test(VM.partial) || vmIsOwnWords(VM.partial))) {
      VM.partial = ''; VM.bargeTurn = false; VM.flushReq = false;
      if (!VM.heard) vmSet('listening', 'Go ahead, I’m listening…');
      return;
    }
    if (!VM.partial) {
      VM.flushReq = false;
      if (!VM.heard) vmSet('listening', text === null ? "Sorry, I couldn't hear that properly. Try again?" : "Sorry, I didn't catch that. Say it again?");
      return;
    }
    if (VM.heard && !VM.flushReq) return;                // they're still talking: wait for the rest
    if (VM.flushReq || !vmUnfinished(VM.partial)) { vmFlush(); return; }
    if (!VM.heard) vmSet('listening', 'Go on, I’m listening…');
  }
  // Is this transcript just Ollie's own voice picked up by the mic? (Most of its words are in what he was
  // saying at the time.)
  function vmIsOwnWords(t) {
    var said = ' ' + String(VM.said || '').toLowerCase().replace(/[^a-z\s']/g, ' ').replace(/\s+/g, ' ') + ' ';
    var common = /^(the|and|for|you|your|you're|with|that|this|its|it's|are|was|have|has|can|will|would|what|how|but|not|all|any|our|out|get|got|one|just|i'm|i'd|i'll|from|into|then|than|there|they|them|yes|yeah|okay)$/;
    var words = String(t).toLowerCase().replace(/[^a-z\s']/g, ' ').split(/\s+/).filter(function (w) { return w.length > 2 && !common.test(w); });
    if (words.length < 3 || said.length < 5) return false;
    var hits = words.filter(function (w) { return said.indexOf(' ' + w + ' ') >= 0; }).length;
    return hits / words.length >= 0.7;
  }
  // Does this sound like they stopped mid-sentence? ("…for a pond that's", "10 metres by", "and")
  var VM_OPEN_END = /\b(and|or|but|by|x|times|the|a|an|for|of|with|to|that's|thats|that|is|are|was|it's|its|my|our|your|about|around|roughly|approximately|like|so|because|which|what|how|i'm|im|i|we|um|uh|er|erm|hmm|in|on|at|from|than|then|if|when|maybe|also|plus|point|looking)$/i;
  function vmUnfinished(t) {
    t = String(t).trim();
    if (/[?!]$/.test(t)) return false;                     // a question or exclamation is a whole thought
    return VM_OPEN_END.test(t.replace(/[\s.,…-]+$/, ''));
  }
  // Send everything they've said this turn as one question, dropping the recording that was waiting
  // for more.
  function vmFlush() {
    var t = VM.partial; VM.partial = ''; VM.flushReq = false; VM.bargeTurn = false;
    if (VM.mr) { var m = VM.mr; VM.mr = null; VM.chunks = []; try { if (m.state !== 'inactive') m.stop(); } catch (e) {} }
    if (t) vmSend(t); else vmListen();
  }
  // Keeps Ollie's current answer in view: while it fits, the whole answer (and the question above it) shows;
  // once it's taller than the caption area, the newest words stay in view as he says them.
  // Re-applied whenever the caption area changes size (product cards arriving, chips, window resizing).
  var followCap = null, capsRO = null;
  function capsFollow(cap) {
    var caps = vmEl && vmEl.querySelector('.ollie-vm__caps');
    if (!caps) return;
    if (cap) followCap = cap;
    if (!capsRO && window.ResizeObserver) { capsRO = new ResizeObserver(function () { capsFollow(); }); capsRO.observe(caps); }
    var c = followCap;
    if (!c || !c.isConnected) { caps.scrollTop = caps.scrollHeight; return; }
    var prev = c.previousElementSibling, top = c.offsetTop - caps.offsetTop - 8;
    if (prev && c.offsetTop + c.offsetHeight - prev.offsetTop <= caps.clientHeight - 8) top = prev.offsetTop - caps.offsetTop - 8;
    // Fits: show it whole (with the question when there's room). Taller: follow the words as they arrive.
    caps.scrollTop = c.offsetHeight > caps.clientHeight - 16 ? caps.scrollHeight : top;
  }
  // A soft fade on the right edge of the product row when more cards are off-screen.
  function shelfMore() {
    var s = vmEl && vmEl.querySelector('.ollie-vm__shelf');
    if (s) s.classList.toggle('is-more', s.scrollWidth - s.clientWidth - s.scrollLeft > 4);
  }

  function vmSend(text) {
    if (!vmOn()) return;
    VM.turns++;
    vmEl.classList.add('is-talking');   // smaller orb: more room for the shelf and captions
    vmChips([]);
    vmCaption('user', '<p>' + esc(text) + '</p>');
    var cap = vmCaption('bot', '<span class="ollie-dots"><i></i><i></i><i></i></span>');
    vmSet('thinking');
    var vo = {
      vm: true,
      onText: function (vis) {
        if (!vmOn()) return;
        VM.said = vis;
        cap.innerHTML = renderMd(vis);
        capsFollow(cap);
        if (VM.state === 'thinking') { vmSet('speaking'); VM.speakT0 = Date.now(); }
      },
      onSpoken: function () { if (vmOn() && (VM.state === 'speaking' || VM.state === 'thinking')) vmAfterSpeech(); }
    };
    var p = VM.ctx === 'pdp' ? pdpAsk(text, vo) : ask(text, vo);
    p.then(function (full) {
      if (!vmOn()) return;
      if (!full) { cap.innerHTML = '<p>Sorry, I couldn’t get an answer just then. Please try again, or ' + TEAM + '</p>'; vmListen(); return; }
      var out = renderReply(full, cap);
      vmChips(out.chips);
      capsFollow(cap);
      out.done.then(function () {
        out.items().slice().reverse().forEach(function (it) { vmShelfAdd(it, false); });
        capsFollow(cap);   // the shelf may have grown and squeezed the captions: keep the answer in view
      });
    });
    track('voice_turn', VM.ctx);
  }
  function vmInterruptAndSend(text) {
    if (!vmOn()) return;
    stopVoice(); vmStopRec(true); VM.partial = ''; VM.flushReq = false;
    vmSend(text);
  }
  function vmOrb() {
    if (!vmOn()) return;
    if (VM.state === 'speaking') { stopVoice(); vmAfterSpeech(); return; }
    // Tapping while listening sends what they've said straight away (a manual 'I'm done').
    if (VM.state === 'hearing' || VM.state === 'listening') {
      VM.flushReq = true;
      if (VM.mr && VM.heard) { vmStopRec(); return; }      // transcribe the last words, then send it all
      if (VM.stt) { vmSet('listening', 'Got it…'); return; } // a part is still being transcribed: sends when it lands
      if (VM.partial) { vmFlush(); return; }
      if (VM.mr) { VM.heard = true; vmStopRec(); return; }
      VM.flushReq = false;
    }
    if (VM.state === 'paused') { vmListen(); return; }
    if (VM.state === 'muted') { vmMute(false); }
  }
  // The button shows the microphone's actual state (what people expect), not the action:
  // a normal mic and "Mic on" while Ollie can hear you; a crossed-out red mic and "Mic off" when muted.
  function vmMuteUi() {
    var b = vmEl.querySelector('[data-vm-mute]'), off = !!(VM && VM.muted);
    b.setAttribute('aria-pressed', off ? 'true' : 'false');
    b.setAttribute('aria-label', off ? 'Microphone off. Tap to turn it on' : 'Microphone on. Tap to turn it off');
    b.classList.toggle('is-off', off);
    b.querySelector('.ollie-vm__ic').innerHTML = off ? MUTE_SVG : MIC_SVG;
    b.querySelector('.ollie-vm__lb').textContent = off ? 'Mic off' : 'Mic on';
  }
  function vmMute(on) {
    if (!vmOn()) return;
    VM.muted = !!on; vmMuteUi();
    if (VM.muted) { vmStopRec(true); if (VM.state !== 'speaking' && VM.state !== 'thinking') vmSet('muted'); }
    else if (VM.state !== 'speaking' && VM.state !== 'thinking') vmListen();
  }
  function vmEnd(typeInstead) {
    if (!VM) return;
    var v = VM; v.active = false;
    if (v.timer) clearInterval(v.timer);
    stopVoice();
    if (v.mr) { v.discard = true; try { if (v.mr.state !== 'inactive') v.mr.stop(); } catch (e) {} }
    if (v.stream) v.stream.getTracks().forEach(function (t) { t.stop(); });
    if (v.ac) { try { v.ac.close(); } catch (e) {} }
    vmEl.classList.remove('is-in'); vmEl.hidden = true;
    document.documentElement.classList.remove('ollie-vm-open');
    VM = null;
    track('voice_end', String(v.turns));
    // Leave them where the conversation continues in text, with the transcript there to read.
    if (v.ctx === 'pdp' && PDP) {
      PDP.box.scrollIntoView({ block: 'nearest' });
      if (typeInstead) PDP.box.querySelector('input').focus();
    } else if (v.turns || typeInstead) {
      open(null, 'voice_end');
      if (typeInstead) setTimeout(function () { input.focus(); }, 60);
    }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && vmOn()) { stopVoice(); vmStopRec(true); vmSet('paused'); }
  });
  // ---------- Wiring ----------
  function init() {
    var mic = document.getElementById('ollieMicSlot');
    if (mic) mic.outerHTML = talkButton("Tap once, then just talk, like a phone call. Ollie answers out loud.");
    if (form.querySelector('.ollie-talk')) form.classList.add('has-talk');
    launch.hidden = false;
    launch.addEventListener('click', function () { panel.hidden ? open(null, 'launcher') : close(); });
    document.getElementById('ollieClose').addEventListener('click', close);
    document.getElementById('ollieRestart').addEventListener('click', reset);
    form.addEventListener('submit', function (e) { e.preventDefault(); var q = input.value.trim(); if (!q) { input.focus(); return; } input.value = ''; ask(q); });
    document.addEventListener('click', function (e) {
      var vb = e.target.closest('[data-ollie-voice]');
      if (vb) { e.preventDefault(); setVoice(!voiceOn, vb.closest('.ollie-e') ? 'pdp' : 'chat'); return; }
      var m = e.target.closest('.ollie-mic');
      if (m) { e.preventDefault(); var f = m.closest('form, [data-ollie-pdp]'); if (f) vmStart(f.hasAttribute('data-ollie-pdp') ? 'pdp' : 'chat'); return; }
      var c = e.target.closest('[data-ollie-ask]');
      if (c) { e.preventDefault(); pdpAsk(c.getAttribute('data-ollie-ask')); return; }
      var send = e.target.closest('[data-ollie-pdp-send]');
      if (send) { e.preventDefault(); pdpSubmit(send.closest('[data-ollie-pdp]')); return; }
      var sqb = e.target.closest('[data-setqty-key]');
      if (sqb) { e.preventDefault(); setQty(sqb); return; }
      var add = e.target.closest('.ollie-add');
      if (add) { e.preventDefault(); addToCart(add); return; }
      var ls = e.target.closest('[data-ollie-lead-send]');
      if (ls) { e.preventDefault(); sendLead(ls.closest('[data-ollie-lead]')); return; }
      var opener = e.target.closest('[data-ollie-open]');
      if (opener) { e.preventDefault(); open(opener.getAttribute('data-ollie-open') || null, 'link'); return; }
      // On phones the chat fills the screen, so a page link inside it (View product, a quote link) must
      // close the chat first; otherwise it restores open on the next page and hides what was tapped.
      var link = e.target.closest('#olliePanel a[href]');
      if (link && !panel.hidden && link.target !== '_blank' && /^https?:$/.test(link.protocol) && link.hostname === location.hostname && window.matchMedia('(max-width: 749px)').matches) close();
    });
    // The product box has no form of its own, so Enter is handled here and never reaches the theme's
    // product form (where it would add to basket).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      // The quote request card: Enter in a one-line field sends it (never the page's product form).
      var lf = e.target.closest && e.target.closest('[data-ollie-lead]');
      if (lf) { if (e.target.tagName === 'TEXTAREA') { e.stopPropagation(); return; } e.preventDefault(); e.stopPropagation(); sendLead(lf); return; }
      var f = e.target.closest && e.target.closest('[data-ollie-pdp]');
      if (f) { e.preventDefault(); e.stopPropagation(); pdpSubmit(f); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; if (vmOn()) { vmEnd(); return; } if (!panel.hidden) close(); });
    // Laptops: in voice mode the Space bar interrupts Ollie, or sends what you've said (same as tapping the circle).
    document.addEventListener('keydown', function (e) {
      if (!vmOn() || (e.key !== ' ' && e.code !== 'Space') || e.repeat) return;
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || (e.target && e.target.isContentEditable)) return;
      e.preventDefault(); vmOrb();
    });
    // Shopify's "I'm not a robot" page: stay closed and out of the way (and keep any pending quote request
    // pending) so nothing covers the tick box.
    if (/^\/challenge/.test(location.pathname)) { launch.hidden = true; return; }
    // Phones: the launcher is a round icon above the theme's bottom bars (the Shop / Search / Basket tab bar,
    // and on product pages the sticky "Add to basket" bar when it shows). --ollie-tabbar is the height they take
    // up from the bottom of the screen (0 when there are none), so Ollie never covers them and glides up and
    // down as the sticky bar comes and goes. The full wording stays as the button's name.
    if (!launch.getAttribute('aria-label')) launch.setAttribute('aria-label', 'Ask Ollie, our matting expert');
    var BARS = '.emh-tabbar, .emx-sticky.is-visible', barGap = -1, barQueued = false;
    function tabbarGap() {
      barQueued = false;
      var vh = window.innerHeight, top = vh;
      [].forEach.call(document.querySelectorAll(BARS), function (el) {
        var s = getComputedStyle(el);
        if (s.display === 'none' || s.visibility === 'hidden' || +s.opacity === 0) return;
        var r = el.getBoundingClientRect();
        if (r.height && r.bottom >= vh - 2 - 120 && r.top < vh && r.top < top) top = r.top;
      });
      var h = Math.max(0, Math.round(vh - top));
      if (h !== barGap) { barGap = h; document.documentElement.style.setProperty('--ollie-tabbar', h + 'px'); }
    }
    function queueGap() { if (!barQueued) { barQueued = true; requestAnimationFrame(tabbarGap); } }
    tabbarGap();
    window.addEventListener('resize', queueGap);
    window.addEventListener('scroll', queueGap, { passive: true });
    window.addEventListener('load', queueGap);
    setTimeout(queueGap, 1500);
    // The sticky bar slides in and out (a short transform transition), so measure again once it has settled.
    var settleTimer = 0;
    function barChanged() { queueGap(); clearTimeout(settleTimer); settleTimer = setTimeout(queueGap, 320); }
    if (window.MutationObserver) {
      var barWatch = new MutationObserver(barChanged);
      barWatch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      [].forEach.call(document.querySelectorAll('.emh-tabbar, .emx-sticky'), function (el) {
        barWatch.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
        el.addEventListener('transitionend', queueGap);
      });
    }
    // First page of a visit on a phone: the round icon opens out to "Ask Ollie" for a few seconds so people know
    // what it is, then folds back. Never on the basket page, never while the chat is open, once per visit.
    try {
      if (window.matchMedia('(max-width: 749px)').matches && !onBasketPage() && !sessionStorage.getItem('ollie_hint')) {
        sessionStorage.setItem('ollie_hint', '1');
        var hint = document.createElement('span'); hint.className = 'ollie-launch__hint'; hint.textContent = 'Ask Ollie'; hint.setAttribute('aria-hidden', 'true');
        launch.appendChild(hint);
        setTimeout(function () { if (panel.hidden) launch.classList.add('is-hint'); }, 1200);
        setTimeout(function () { launch.classList.remove('is-hint'); setTimeout(function () { if (hint.parentNode) hint.remove(); }, 400); }, 6200);
      }
    } catch (e) {}
    // A conversation left open on another page is kept, but on the basket page it stays closed until asked for.
    if (restore() && !onBasketPage()) open(null, 'restore');
    leadReturn();
    mountProductBox();
    setVoice(voiceOn, false);
    window.OllieChat = {
      open: function (q, source) { open(q || null, source || 'api'); },
      close: close,
      toggle: function () { panel.hidden ? open(null, 'api') : close(); },
      // Opens the chat and starts listening straight away (the header search mic). Must run inside a click.
      talk: function () { vmStart('chat'); },
      endTalk: function () { vmEnd(); }
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
